import { useEffect, useRef, useState, useCallback } from "react";
import { json, useParams, useLocation, useNavigate } from "react-router-dom";
import grapesjs from "grapesjs";
import { callApi, getCurSiteId } from "../../lib/Common_funcs";
import { templateThemes, fontThemes, colorThemes } from "./FontColorTheme";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Button from 'react-bootstrap/Button';
import "grapesjs/dist/css/grapes.min.css";
import "./TemplateEditor.css";

import Accordion from "react-bootstrap/Accordion";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Popover from 'react-bootstrap/Popover'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

// Chatscope Imports
import styles from '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { MainContainer, ChatContainer, MessageList, Message, MessageInput, Avatar, AttachmentButton } from '@chatscope/chat-ui-kit-react';

// React Icons Import
import { FiMonitor, FiArrowLeft, FiEdit3, FiSearch, FiSettings, FiMaximize2, FiMinimize2, FiX } from "react-icons/fi";
import { BsInfoCircleFill } from "react-icons/bs";
import { FaTabletAlt } from "react-icons/fa";
import { FaMobileAlt } from "react-icons/fa";
import { FaRobot } from "react-icons/fa6";
import { FaFolderOpen } from "react-icons/fa6"

const TemplateEditor = () => {
  const EditedDataJSON = JSON.parse(localStorage.getItem("EditedDataJson"));
  const templateJSON = JSON.parse(localStorage.getItem("templateJSON"));

  const location = useLocation();
  const navigate = useNavigate();
  const { templateId } = useParams();
  const containerRef = useRef(null);
  const editorRef = useRef(null);
  const settingsPanelRef = useRef(null);
  // const [existingTemplateJSON, setExistingTemplateJSON] = useState(
  //   EditedDataJSON?.saveData || {}
  // );
  const [templateData, setTemplateData] = useState(null);
  const [selectedPageIndex, setSelectedPageIndex] = useState(0);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [componentContent, setComponentContent] = useState("");
  const [componentHref, setComponentHref] = useState("");
  const [componentAlt, setComponentAlt] = useState("");
  const [componentSrc, setComponentSrc] = useState("");
  const [device, setDevice] = useState("Desktop");
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [seoPerPage, setSeoPerPage] = useState({});
  const [customCodePerPage, setCustomCodePerPage] = useState({});
  const [customCode, setCustomCode] = useState({ head_js: '' });
  const [customCodeGlobal, setCustomCodeGlobal] = useState({ head_js: '' });
  const [customCodeFetching, setCustomCodeFetching] = useState(false);
  const [globalSectionExpanded, setGlobalSectionExpanded] = useState(false);
  const [pageSectionExpanded, setPageSectionExpanded] = useState(true);
  const customCodeInitialized = useRef(false);
  const [activeTab, setActiveTab] = useState("properties");
  const [seoData, setSeoData] = useState({
    meta_title: "",
    meta_description: "",
    keywords: "",
    canonicalUrl: "",
    robots: "",
    ogType: "",
    og_title: "",
    og_description: "",
    ogImage: "",
    twitterCard: "",
    schema_org: "",
  });
  const [imageUrlInput, setImageUrlInput] = useState("");
  const [allChangedComponents, setAllChangedComponents] = useState(new Set());
  const [originalSeoData, setOriginalSeoData] = useState({});
  const [originalPageContents, setOriginalPageContents] = useState({});
  const [modifiedPageContents, setModifiedPageContents] = useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [sharedComponentChanges, setSharedComponentChanges] = useState({});
  const [pageEditedData, setPageEditedData] = useState({});
  const [originalComponentData, setOriginalComponentData] = useState({});
  const [showBackPopUp, setShowBackPopUp] = useState(false);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [extractedAssets, setExtractedAssets] = useState({});
  const [error, setError] = useState("");
  const [templateJson, setTemplateJson] = useState("");
  const [faviconUrlInput, setFaviconUrlInput] = useState("");
  const [currentFavicon, setCurrentFavicon] = useState("");
  const [acctSid, setAcctSid] = useState("");
  const [siteId, setSiteid] = useState(getCurSiteId());

  const [act_e, setAct_E] = useState("");
  const [assetsCollection, setAssetsCollection] = useState([]);
  const [publicSiteId, setPublicSiteId] = useState("");
  const [publicKey, setPublicKey] = useState("");
  const [curSiteName, setCurSiteName] = useState("");
  // const [loadedCss, setLoadedCss] = useState('')
  const [editableTheme, setEditableTheme] = useState({});
  const [originalTheme, setOriginalTheme] = useState({});
  const [editableFonts, setEditableFonts] = useState({});
  const [originalFonts, setOriginalFonts] = useState({});
  const [selectedColorTheme, setSelectedColorTheme] = useState("");
  const [selectedFontTheme, setSelectedFontTheme] = useState("");
  const [showCustomColorPicker, setShowCustomColorPicker] = useState(false);
  const [showCustomFontPicker, setShowCustomFontPicker] = useState(false);
  const [showColorThemes, setShowColorThemes] = useState(false);
  const [showFontThemes, setShowFontThemes] = useState(false);
  const [showCustomCodeEditor, setShowCustomCodeEditor] = useState(false);

  useEffect(() => {
    if (showCustomColorPicker || showCustomFontPicker || showColorThemes || showFontThemes || showCustomCodeEditor) {
      settingsPanelRef.current?.scrollTo({ top: 0 });
    }
  }, [showCustomColorPicker, showCustomFontPicker, showColorThemes, showFontThemes, showCustomCodeEditor]);

  const [loading, setLoading] = useState(false);
  const [startAt, setstartAt] = useState("");
  const [fetchData, setFetchData] = useState(false);
  const [siteData, setSiteData] = useState({});

  const [message, setMessage] = useState([])
  const [messageLoader, setMessageLoader] = useState(false)

  const TemplateHTML = useRef("");
  const existingTemplateJSON = useRef(EditedDataJSON?.saveData || {})
  const fileRef = useRef(null);

  const AiRequestBodyRef = useRef({
    template_type: "Salon-1",
    page: "",
    schema_version: "1.0.0",
    messages: [],
    fields: templateJSON?.data?.AiChatHistory || {},
    // fields: {}
  })

  const [show, setShow] = useState(false);
  const [aiExpanded, setAiExpanded] = useState(false);
  const [showGallery, setShowGallery] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const acctId = localStorage.getItem("turbosteedAcct");
    const curSite = localStorage.getItem("curSite");
    const curSiteIdx = localStorage.getItem("curSiteIdx");
    const currentSites = JSON.parse(localStorage.getItem("sites") || "[]");
    const act_2_Turbo = localStorage.getItem("act_e");

    if (acctId) setAcctSid(acctId);
    if (act_2_Turbo) setAct_E(act_2_Turbo);
    if (curSite) setCurSiteName(curSite);
    // if (currentSites && currentSites[curSiteIdx]) {
    //   setSiteid(currentSites[curSiteIdx]["siteId"]);
    // }
  }, []);

  const handleColorThemeChange = (themeName) => {
    if (themeName === "custom") {
      setShowCustomColorPicker(true);
      return;
    }

    setSelectedColorTheme(themeName);
    const themeColors = colorThemes[themeName];

    if (themeColors) {
      const updatedTheme = { ...editableTheme };
      Object.keys(themeColors).forEach((property) => {
        updatedTheme[property] = themeColors[property];
      });

      setEditableTheme(updatedTheme);

      // Preserve current font settings when applying color theme
      applyThemeChanges(updatedTheme, editableFonts);
      setShowCustomColorPicker(false);
    }
  };

  const handleFontThemeChange = (themeName) => {
    if (themeName === "custom") {
      setShowCustomFontPicker(true);
      return;
    }

    setSelectedFontTheme(themeName);
    const themeFonts = fontThemes[themeName];

    if (themeFonts) {
      const updatedFonts = { ...editableFonts };
      Object.keys(themeFonts).forEach((property) => {
        updatedFonts[property] = themeFonts[property];
      });

      setEditableFonts(updatedFonts);

      // Preserve current color settings when applying font theme
      applyThemeChanges(editableTheme, updatedFonts);
      setShowCustomFontPicker(false);
    }
  };

  // useEffect(() => {
  //   const loadTemplateJSONData = () => {
  //     try {
  //       const JsonData = localStorage.getItem('templateJSON');
  //       if (!JsonData) {
  //         // console.log('No JSON data found in localStorage');
  //         setExistingTemplateJSON({});
  //         return;
  //       }

  //       const parsedData = JSON.parse(JsonData);
  //       // console.log('Loaded JSON data from localStorage:', parsedData);

  //       // let templateData;
  //       // if (parsedData.data && parsedData.data.templateData) {
  //       //   templateData = parsedData.data.templateData;
  //       // } else if (parsedData.templateData) {
  //       //   templateData = parsedData.templateData;
  //       // } else {
  //       //   console.warn('Unexpected JSON structure:', parsedData);
  //       //   setExistingTemplateJSON({});
  //       //   return;
  //       // }

  //       const formattedData = {
  //         templateData: parsedData.templateData || {},
  //         sharedComponents: parsedData.sharedComponents || {},
  //         branding: parsedData.branding || {},
  //         themeCustomization: parsedData.themeCustomization || {}
  //       };
  //       setExistingTemplateJSON(formattedData);
  //     } catch (error) {
  //       console.error("Error fetching existing JSON", error);
  //       setExistingTemplateJSON({});
  //     }
  //   };

  //   loadTemplateJSONData();
  // }, []);


  const handleFaviconUpload = async (event) => {
    const file = event.target.files[0];
    if (!file || !templateData) return;

    try {
      setIsLoading(true);

      // Validate file type
      const validTypes = [
        "image/x-icon",
        "image/vnd.microsoft.icon",
        "image/png",
        "image/jpeg",
        "image/jpg",
      ];
      if (
        !validTypes.includes(file.type) &&
        !file.name.match(/\.(ico|png|jpg|jpeg)$/i)
      ) {
        alert("Please select a valid favicon file (ICO, PNG, JPG format)");
        return;
      }

      // Validate file size
      const maxSizeInMB = 5;
      if (file.size > maxSizeInMB * 1024 * 1024) {
        alert(`Favicon size must be less than ${maxSizeInMB}MB`);
        return;
      }

      // Upload the favicon - use a different endpoint or parameter
      const uploadUrl = `https://${process.env.REACT_APP_HOST_URL}/users/${acctSid}/sites/${siteId}/assets`;
      const formData = new FormData();
      formData.append("image", file);

      const response = await fetch(uploadUrl, {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: {
          Authorization: "Basic " + btoa(acctSid + ":" + act_e),
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Upload failed: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
      // console.log('Favicon upload result:', result);

      // Get the image path from the response
      const faviconPath =
        result.fileUrl || result.url || result.path || result.imagePath;

      if (!faviconPath) {
        throw new Error("No favicon URL returned from server");
      }

      // Make sure the path is a full URL
      const fullFaviconPath = faviconPath.startsWith("http")
        ? faviconPath
        : `${templateData.templateBaseUrl}${faviconPath}`;

      // Update the favicon in the editor
      updateFaviconInEditor(fullFaviconPath);

      setFaviconUrlInput(fullFaviconPath);
      setCurrentFavicon(fullFaviconPath);

      // Mark as changed
      setAllChangedComponents((prev) => new Set([...prev, "favicon"]));
      setHasUnsavedChanges(true);

      event.target.value = "";
    } catch (error) {
      console.error("Error uploading favicon:", error);
      alert("Error uploading favicon: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFaviconUrl = async (event) => {
    const faviconUrl = event.target.value.trim();
    if (!faviconUrl) return;

    try {
      setIsLoading(true);

      // Validate URL
      try {
        new URL(faviconUrl);
      } catch (urlError) {
        alert(
          "Please enter a valid URL (e.g., https://example.com/favicon.ico)"
        );
        return;
      }

      // Update the favicon in the editor
      updateFaviconInEditor(faviconUrl);

      setCurrentFavicon(faviconUrl);

      // Mark as changed
      setAllChangedComponents((prev) => new Set([...prev, "favicon"]));
      setHasUnsavedChanges(true);

      event.target.value = "";
    } catch (error) {
      console.error("Error setting favicon URL:", error);
      alert("Error setting favicon URL: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const updateFaviconInEditor = (faviconUrl) => {
    if (!editorRef.current) return;

    const canvasDoc = editorRef.current.Canvas.getDocument();
    if (!canvasDoc) return;

    // Find the existing favicon link
    const faviconLink = canvasDoc.querySelector('link[rel*="icon"]');

    if (!faviconLink) {
      console.error("Favicon <link> tag not found in the canvas document.");
      return;
    }

    // Extract ID
    const faviconId = faviconLink.getAttribute("id");
    if (!faviconId) {
      console.error('Favicon tag found but has no "id" attribute.');
      return;
    }

    // Update the href
    faviconLink.setAttribute("href", faviconUrl);

    // Update shared component changes with the extracted ID
    setSharedComponentChanges((prev) => ({
      ...prev,
      favicon: [
        {
          id: faviconId,
          tag: "link",
          rel: "icon",
          imageUrl: faviconUrl,
          href: faviconUrl,
        },
      ],
    }));
  };

  // const applyJsonDataToHtml = (html, jsonData, pageName) => {
  //   if (!jsonData?.templateData?.pages) return html;

  //   const pageKey = pageName.includes('.html') ? pageName : `${pageName}.html`;
  //   const pageData = jsonData.templateData.pages[pageKey];

  //   if (!pageData || !pageData.EditedData) return html;

  //   const doc = new DOMParser().parseFromString(html, 'text/html');

  //   pageData.EditedData.forEach(editedElement => {
  //     const element = doc.getElementById(editedElement.id);
  //     if (!element) {
  //       console.warn(`Element with ID ${editedElement.id} not found`);
  //       return;
  //     }

  //     if (editedElement.content !== undefined && editedElement.tag !== 'img') {
  //       if (element.tagName.toLowerCase() === 'input') {
  //         element.setAttribute('value', editedElement.content);
  //       } else {
  //         // For text elements, replace text content but preserve HTML structure
  //         element.textContent = editedElement.content;
  //       }
  //     }

  //     // Apply image URL changes
  //     if (editedElement.imageUrl !== undefined && element.tagName.toLowerCase() === 'img') {
  //       element.setAttribute('src', editedElement.imageUrl);
  //     }

  //     // Apply image alt text changes
  //     if (editedElement.imageAltText !== undefined && element.tagName.toLowerCase() === 'img') {
  //       element.setAttribute('alt', editedElement.imageAltText);
  //     }

  //     // Apply link changes
  //     if (editedElement.linkDetails !== undefined) {
  //       if (editedElement.linkDetails) {
  //         element.setAttribute('href', editedElement.linkDetails);
  //       } else {
  //         element.removeAttribute('href');
  //       }
  //     }
  //   });
  //   // Apply Shared Component Changes Including Favicon
  //   if (jsonData.sharedComponents && Object.keys(jsonData.sharedComponents).length > 0) {
  //     Object.entries(jsonData.sharedComponents).forEach(([sharedId, sharedData]) => {
  //       if (sharedId === 'favicon' && Array.isArray(sharedData)) {
  //         // Handle favicon as shared component
  //         sharedData.forEach(faviconEdit => {
  //           if (faviconEdit.imageUrl) {
  //             let faviconLink = doc.querySelector('link[rel*="icon"]');
  //             if (!faviconLink) {
  //               faviconLink = doc.createElement('link');
  //               faviconLink.setAttribute('rel', 'icon');
  //               faviconLink.setAttribute('data-shared', 'favicon');
  //               doc.head.appendChild(faviconLink);
  //             }
  //             faviconLink.setAttribute('href', faviconEdit.imageUrl);
  //           }
  //         });
  //       } else {
  //         // Handle other shared components (navbar, footer)
  //         const sharedElements = doc.querySelectorAll(`[data-shared="${sharedId}"]`);
  //         sharedElements.forEach(element => {
  //           if (Array.isArray(sharedData)) {
  //             sharedData.forEach(edit => {
  //               const targetElement = element.querySelector(`#${edit.id}`) ||
  //                 (element.id === edit.id ? element : null);
  //               if (targetElement && edit.content !== undefined) {
  //                 targetElement.textContent = edit.content;
  //               }
  //               if (targetElement && edit.imageUrl !== undefined) {
  //                 targetElement.setAttribute('src', edit.imageUrl);
  //               }
  //               if (targetElement && edit.linkDetails !== undefined) {
  //                 if (edit.linkDetails) {
  //                   targetElement.setAttribute('href', edit.linkDetails);
  //                 } else {
  //                   targetElement.removeAttribute('href');
  //                 }
  //               }
  //             });
  //           }
  //         });
  //       }
  //     });
  //   }

  //   // Apply SEO data to head section
  //   if (pageData.SEO && pageData.SEO.length > 0) {
  //     const seoData = pageData.SEO[0];

  //     // Update title
  //     if (seoData.title) {
  //       let titleElement = doc.querySelector('title');
  //       if (!titleElement) {
  //         titleElement = doc.createElement('title');
  //         doc.head.appendChild(titleElement);
  //       }
  //       titleElement.textContent = seoData.title;
  //     }

  //     // Update meta description
  //     if (seoData.description) {
  //       let metaDesc = doc.querySelector('meta[name="description"]');
  //       if (!metaDesc) {
  //         metaDesc = doc.createElement('meta');
  //         metaDesc.setAttribute('name', 'description');
  //         doc.head.appendChild(metaDesc);
  //       }
  //       metaDesc.setAttribute('content', seoData.description);
  //     }

  //     // Update meta keywords
  //     if (seoData.metaTags) {
  //       let metaKeywords = doc.querySelector('meta[name="keywords"]');
  //       if (!metaKeywords) {
  //         metaKeywords = doc.createElement('meta');
  //         metaKeywords.setAttribute('name', 'keywords');
  //         doc.head.appendChild(metaKeywords);
  //       }
  //       metaKeywords.setAttribute('content', seoData.metaTags);
  //     }
  //   }

  //   return doc.documentElement.outerHTML;
  // };
  // const populateEditorStateFromJson = (jsonData) => {
  //   // console.log("Json Data passed to populateEditorState", jsonData.themeCustomization)
  //   console.log("populate editor state from json ", jsonData)
  //   if (!jsonData?.templateData?.pages) return;
  //   const seoDataPerPage = {};
  //   Object.entries(jsonData.templateData.pages).forEach(([pageName, pageData]) => {
  //     const pageUrl = templateData?.templateFiles?.templatePageURLs?.find(url => {
  //       const urlPageName = url.split('/').pop();
  //       return urlPageName === pageName || url.includes(pageName);
  //     });

  //     if (pageUrl && pageData.SEO && pageData.SEO.length > 0) {
  //       const seoInfo = pageData.SEO[0];
  //       seoDataPerPage[pageUrl] = {
  //         title: seoInfo.title || "",
  //         description: seoInfo.description || "",
  //         keywords: seoInfo.metaTags || "",
  //       };
  //     }
  //   });

  //   setSeoPerPage(seoDataPerPage);

  //   // Track changed components
  //   const changedComponents = new Set();
  //   Object.values(jsonData.templateData.pages).forEach(pageData => {
  //     if (pageData.EditedData && Array.isArray(pageData.EditedData)) {
  //       pageData.EditedData.forEach(edit => {
  //         if (edit.id) {
  //           changedComponents.add(edit.id);
  //         }
  //       });
  //     }
  //   });
  //   setAllChangedComponents(changedComponents);

  //   if (changedComponents.size > 0) {
  //     setHasUnsavedChanges(true);
  //   }

  //   // Handle shared components
  //   if (jsonData.sharedComponents && Object.keys(jsonData.sharedComponents).length > 0) {
  //     setSharedComponentChanges(jsonData.sharedComponents);
  //   }
  //   const canvasDoc = editorRef.current.Canvas.getDocument();
  //   console.log("Custom font varibales", jsonData)
  //   if (jsonData.themeCustomization) {
  //     console.log('Loading theme customization from JSON:', jsonData.themeCustomization.customVariables);
  //     if (jsonData.themeCustomization.customVariables) {
  //       Object.entries(jsonData.themeCustomization.customVariables).forEach(([property, value]) => {
  //         canvasDoc.documentElement.style.setProperty(property, value, 'important');
  //       })
  //     }
  //     if (jsonData.themeCustomization.customFontVariables) {
  //       Object.entries(jsonData.themeCustomization.customFontVariables).forEach(([property, value]) => {
  //         canvasDoc.documentElement.style.setProperty(property, value, 'important');
  //       })
  //     }
  //   }
  //   console.log(canvasDoc)
  //   // const allVariables = { ...themeVars, ...fontVars };

  //   //   Object.entries(allVariables).forEach(([property, value]) => {
  //   //     canvasDoc.documentElement.style.setProperty(property, value, 'important');
  //   //   });

  //   //   // Force refresh
  //   //   const canvasWindow = editorRef.current.Canvas.getWindow();
  //   //   if (canvasWindow) {
  //   //     canvasDoc.body.style.display = 'none';
  //   //     canvasDoc.body.style.display = '';
  //   //     canvasWindow.dispatchEvent(new canvasWindow.Event('resize'));
  //   //   }
  // };

  useEffect(() => {
    const fetchStyleContent = async () => {
      try {
        const hostUrl = process.env.REACT_APP_HOST_DOMAIN;
        const baseUrl = `https://${hostUrl}/templates/${templateId}`;
        const possibleFiles = ["style.css", "styles.css", "Style.css"];

        let styleContent = null;

        // for (let file of possibleFiles) {
        // const url = `${baseUrl}/${file}`;

        const randomKey = `${Date.now()}-${Math.random()
          .toString(36)
          .substring(2, 15)}`;

        const url = `${baseUrl}/style.css?turbonckey=${randomKey}`;
        // const url = `${baseUrl}/Style.css`

        // let url = 'http://100.124.16.42:4000/style'
        try {
          // console.log("fetching stylesheets the url: ", url)
          const response = await fetch(url, { method: "GET" });

          console.log("Fetching Style Sheets: ", response);
          console.log(response);

          if (response.ok) {
            const data = await response.text();
            extractThemeFromStyles(data);
            // break;
          }
        } catch (error) {
          console.log("Error Fetching StyleSheet: ", error);
          // console.warn(`Failed to fetch ${url}:`, error);
        }
        // }
      } catch (error) {
        console.error("Error fetching stylesheet:", error);
      }
    };

    fetchStyleContent();
  }, [templateId]);

  const extractThemeFromStyles = (styles) => {
    try {
      console.log("Extracting theme from styles: ", styles);
      const withoutComments = styles.replace(/\/\*[\s\S]*?\*\//g, "");
      const rootMatch = withoutComments.match(/:root\s*{([^}]*)}/);
      console.log("Root Match: ", rootMatch);
      if (!rootMatch) {
        return { themeVars: {}, fontVars: {} };
      }

      const rootContent = rootMatch[1];
      const lines = rootContent
        .split(";")
        .map((line) => line.trim())
        .filter(Boolean);

      const cssThemeVars = {};
      const cssFontVars = {};

      lines.forEach((line) => {
        const [property, value] = line.split(":").map((part) => part.trim());
        if (!property || !value) return;

        const isBaseThemeVar = /^--(dark|light|accent-\d+)$/i.test(property);
        const isFontVar =
          /^--font-(primary|heading|body|base|family|size|weight)/i.test(
            property
          );

        if (isBaseThemeVar) {
          cssThemeVars[property] = value;
        } else if (isFontVar) {
          cssFontVars[property] = value;
        }
      });

      setOriginalTheme(cssThemeVars);
      setOriginalFonts(cssFontVars);

      console.log("Extracted Theme Vars: ", cssThemeVars);
      console.log("ExistingTemplateJSON: ", existingTemplateJSON);

      if (
        !existingTemplateJSON?.themeCustomization?.customVariables ||
        Object.keys(existingTemplateJSON?.themeCustomization?.customVariables)
          .length === 0
      ) {
        console.log("Setting editable theme vars from extracted css");
        setEditableTheme(cssThemeVars);
        // applyThemeChanges(cssThemeVars, cssFontVars);
      }

      if (
        !existingTemplateJSON?.themeCustomization?.customFontVariables ||
        Object.keys(
          existingTemplateJSON?.themeCustomization?.customFontVariables
        ).length === 0
      ) {
        setEditableFonts(cssFontVars);
        // applyThemeChanges(cssThemeVars, cssFontVars);
      }

      return { themeVars: cssThemeVars, fontVars: cssFontVars };
    } catch (error) {
      console.error("Error extracting theme from styles: ", error);
    }
  };

  const applyThemeChanges = (
    themeVars = editableTheme,
    fontVars = editableFonts
  ) => {
    if (!editorRef.current) {
      console.log("Not Applying themes");
      return;
    }

    try {
      const canvasDoc = editorRef.current.Canvas.getDocument();
      if (!canvasDoc) return;

      console.log("Applying Theme Changes: ", themeVars, fontVars);

      // Apply both color and font variables together
      const allVariables = { ...themeVars, ...fontVars };

      Object.entries(allVariables).forEach(([property, value]) => {
        canvasDoc.documentElement.style.setProperty(
          property,
          value,
          "important"
        );
      });

      console.log("Canvas Doc : ", canvasDoc);

      // Force refresh
      const canvasWindow = editorRef.current.Canvas.getWindow();
      if (canvasWindow) {
        console.log("Editor Refresh");
        canvasDoc.body.style.display = "none";
        canvasDoc.body.style.display = "";
        canvasWindow.dispatchEvent(new canvasWindow.Event("resize"));
      }

      setEditableTheme(themeVars);
      setEditableFonts(fontVars);
      setHasUnsavedChanges(true);
    } catch (error) {
      console.error("Error applying theme/font changes:", error);
    }
  };

  const applyStoredThemesToNewPage = () => {
    if (!editorRef.current) return;

    setTimeout(() => {
      try {
        const canvasDoc = editorRef.current.Canvas.getDocument();
        if (!canvasDoc) return;

        const allVariables = { ...editableTheme, ...editableFonts };

        Object.entries(allVariables).forEach(([property, value]) => {
          canvasDoc.documentElement.style.setProperty(
            property,
            value,
            "important"
          );
        });

        const canvasWindow = editorRef.current.Canvas.getWindow();
        if (canvasWindow) {
          canvasDoc.body.style.display = "none";
          canvasDoc.body.style.display = "";
          canvasWindow.dispatchEvent(new canvasWindow.Event("resize"));
        }
      } catch (error) {
        console.error("Error applying stored themes to new page:", error);
      }
    }, 500);
  };

  useEffect(() => {
    console.log("Apply Theme Changes UseEffect Called");
    console.log("Editor Ref: ", editorRef.current);
    if (editorRef.current) {
      console.log(
        "Applying theme changes from useEffect: ",
        editableTheme,
        editableFonts
      );
      applyThemeChanges(editableTheme, editableFonts);
    } else {
      console.log("Calling applythemeChanges after sometime");
      setTimeout(() => applyThemeChanges(editableTheme, editableFonts), 9000);
    }
  }, [editableTheme, editableFonts]);

  const handleFontChange = (property, newValue) => {
    const updatedFonts = {
      ...editableFonts,
      [property]: newValue,
    };

    setEditableFonts(updatedFonts);

    applyThemeChanges(editableTheme, updatedFonts);
  };

  const resetFontsToOriginal = () => {
    setEditableFonts(originalFonts);
    applyThemeChanges(editableTheme, originalFonts);
  };

  const getFontFriendlyName = (variable) => {
    const nameMap = {
      "--font-primary": "Primary Font",
      "--font-heading": "Heading Font",
    };

    return (
      nameMap[variable] ||
      variable
        .replace("--font-", "")
        .replace(/-/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase())
    );
  };

  const handleThemeColorChange = (property, newColor) => {
    const updatedTheme = {
      ...editableTheme,
      [property]: newColor,
    };

    setEditableTheme(updatedTheme);

    applyThemeChanges(updatedTheme, editableFonts);
  };

  const resetThemeToOriginal = () => {
    setEditableTheme(originalTheme);
    applyThemeChanges(originalTheme);
  };

  const getVariableFriendlyName = (variable) => {
    const nameMap = {
      "--dark": "Dark Color",
      "--light": "Light Color",
      "--accent-1": "Primary Accent",
      "--accent-2": "Secondary Accent",
      "--accent-3": "Tertiary Accent",
      "--accent-4": "Fourth Accent",
      "--accent-5": "Fifth Accent",
    };

    return (
      nameMap[variable] ||
      variable.replace("--", "").replace("-", " ").toUpperCase()
    );
  };

  useEffect(() => {
    const fetchImages = async () => {
      if (!acctSid || !siteId || !act_e) return;

      // console.log("Now fetching assets");

      try {
        const fetchImageUrl =
          startAt !== ""
            ? `https://${process.env.REACT_APP_HOST_URL}/users/${acctSid}/sites/${siteId}/assets?startAt=${startAt}`
            : `https://${process.env.REACT_APP_HOST_URL}/users/${acctSid}/sites/${siteId}/assets`;
        const response = await fetch(fetchImageUrl, {
          method: "GET",
          credentials: "include",
          headers: {
            Authorization: "Basic " + btoa(acctSid + ":" + act_e),
          },
        });

        const data = await response.json();
        // console.log(data.images)
        const data_startAt = data?.startAt;
        setstartAt(data?.startAt);
        assetsCollection.push(...(data?.files || []));
        setFetchData(data_startAt === "" ? fetchData : !fetchData);
        console.log("Fetching Image: ", assetsCollection);

        // console.log('Fetched images:', data);
      } catch (error) {
        console.error("Fetch images error:", error);
      }
    };

    fetchImages();
  }, [acctSid, siteId, act_e, fetchData]);

  const togglePopup = () => {
    setShowBackPopUp(!showBackPopUp);
  };

  const closePopup = () => {
    setShowBackPopUp(false);
    setShowSuccessPopUp(false);
  };

  const exitPopup = () => {
    setShowBackPopUp(false);
    setShowSuccessPopUp(false);
    window.history.back();
  };

  //  saveImageToTemplateFolder function
  const saveImageToTemplateFolder = async (
    file,
    templateBase,
    isFavicon = false
  ) => {
    try {
      const uploadUrl = `https://${process.env.REACT_APP_HOST_URL}/users/${acctSid}/sites/${siteId}/assets`;
      const formData = new FormData();
      formData.append("image", file);

      // Add parameter to indicate if it's a favicon
      if (isFavicon) {
        formData.append("isFavicon", "true");
      }

      const response = await fetch(uploadUrl, {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: {
          Authorization: "Basic " + btoa(acctSid + ":" + act_e),
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Upload failed: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
      // console.log('Upload result:', result);
      const imagePath =
        result.fileUrl || result.url || result.path || result.imagePath;

      if (!imagePath) {
        throw new Error("No image URL returned from server");
      }

      return imagePath.startsWith("http")
        ? imagePath
        : `${templateBase}${imagePath}`;
    } catch (error) {
      console.error("Error saving image:", error);
      throw error;
    }
  };

  const patchImagePaths = (html, basePath) => {
    return html.replace(/<img\s+[^>]*?(?<!-)src=["']([^"']+)["']/g, (match, src) => {
      if (src.startsWith("http") || src.startsWith("/")) return match;
      const cleanSrc = src.replace(/^\.\//, "");
      return match.replace(src, `${basePath}${cleanSrc}`);
    });
  };

  //  function to extract external styles and scripts
  const extractExternalStylesAndScripts = (html) => {
    const styles = [];
    const scripts = [];

    const linkTagRegex =
      /<link\s+[^>]*rel=["']stylesheet["'][^>]*href=["']([^"']+)["'][^>]*>/gi;

    let match;
    while ((match = linkTagRegex.exec(html)) !== null) {
      styles.push({
        href: match[1],
        name:
          match[1].split("/").pop() ||
          "style.css" ||
          "styles.css" ||
          "Style.css",
        fullTag: match[0],
      });
    }

    //     const targetDomain = 'abcd.turbosteed-staging.com';

    // while ((match = linkTagRegex.exec(html)) !== null) {
    //   let href = match[1]?.trim() || '';

    //   // Replace the domain dynamically
    //   href = href.replace(/https:\/\/[^/]+/, `https://${targetDomain}`);

    //   // Extract clean filename (no query params)
    //   const filename = href.split('/').pop()?.split('?')[0] || 'style.css';

    //   // Replace inside fullTag as well
    //   const fullTag = match[0]
    //     .replace(/https:\/\/[^/]+/, `https://${targetDomain}`)
    //     .replaceAll('\\"', '"'); // remove any escaped quotes if they exist

    //   styles.push({
    //     href,
    //     name: filename,
    //     fullTag
    //   });
    // }

    const scriptSrcRegex =
      /<script\s+[^>]*src=["']([^"']+)["'][^>]*><\/script>/gi;
    while ((match = scriptSrcRegex.exec(html)) !== null) {
      scripts.push({
        src: match[1],
        name: match[1].split("/").pop() || "script.js",
        fullTag: match[0],
      });
    }

    const inlineScriptRegex = /<script(?:\s+[^>]*)?>([\s\S]*?)<\/script>/gi;
    while ((match = inlineScriptRegex.exec(html)) !== null) {
      if (!match[0].includes("src=")) {
        scripts.push({
          content: match[1].trim(),
          name: "inline-script",
          isInline: true,
          fullTag: match[0],
        });
      }
    }
    // console.log(styles)
    console.log(styles);
    return { styles, scripts };
  };

  const extractImagesFromHtml = (html) => {
    const images = [];
    const imgRegex = /<img\s+[^>]*src=["']([^"']+)["'][^>]*>/g;
    let match;
    while ((match = imgRegex.exec(html)) !== null) {
      images.push({
        src: match[1],
        name: match[1].split("").pop() || "Image",
      });
    }
    return images;
  };

  // Add this new function after extractImagesFromHtml function
  const reinitializeAnimations = () => {
    if (!editorRef.current) return;

    setTimeout(() => {
      const canvasDoc = editorRef.current.Canvas.getDocument();
      const canvasWindow = editorRef.current.Canvas.getWindow();

      if (canvasDoc && canvasWindow) {
        // Re-trigger any animation initialization scripts
        const animationScripts = canvasDoc.querySelectorAll("script");

        animationScripts.forEach((script) => {
          if (
            script.src &&
            (script.src.includes("aos") ||
              script.src.includes("animate") ||
              script.src.includes("scroll") ||
              script.src.includes("wow") ||
              script.src.includes("gsap") ||
              script.src.includes("lottie"))
          ) {
            // Reload animation library
            const newScript = canvasDoc.createElement("script");
            newScript.src = script.src;
            newScript.onload = () => {
              // Initialize after loading
              if (canvasWindow.AOS) {
                canvasWindow.AOS.init({
                  duration: 1000,
                  once: false,
                  mirror: true,
                });
              }

              if (canvasWindow.WOW) {
                new canvasWindow.WOW().init();
              }
            };
            canvasDoc.head.appendChild(newScript);
          }
        });

        // Initialize common animation libraries if they already exist
        if (canvasWindow.AOS) {
          canvasWindow.AOS.init({
            duration: 1000,
            once: false,
            mirror: true,
          });
        }

        if (canvasWindow.WOW) {
          new canvasWindow.WOW().init();
        }

        // Trigger scroll events to activate animations
        canvasWindow.dispatchEvent(new canvasWindow.Event("scroll"));
        canvasWindow.dispatchEvent(new canvasWindow.Event("resize"));
        canvasWindow.dispatchEvent(new canvasWindow.Event("load"));
      }
    }, 1000);
  };

  const handleComponentSelected = (comp) => {
    const tagName = comp.get("tagName").toLowerCase();

    // setActiveTab("properties")

    // UPDATED: More restrictive selection criteria
    const selectableTypes = ["text", "link", "default", "image", "Video"];
    const selectableTags = [
      "a",
      "button",
      "span",
      "p",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "img",
      "input",
      "video",
    ];
    const nonSelectableTags = [
      "div",
      "section",
      "main",
      "article",
      "aside",
      "nav",
      "header",
      "footer",
      "svg",
      "i",
      "body",
      "html",
    ];

    // Reject container elements
    if (nonSelectableTags.includes(tagName)) {
      console.log("Rejecting the update: ", tagName);

      setSelectedComponent(null);
      setComponentContent("");
      setComponentHref("");
      setComponentAlt("");
      setComponentSrc("");
      return;
    }

    if (
      selectableTypes.includes(comp.get("type")) ||
      selectableTags.includes(tagName)
    ) {
      setSelectedComponent(comp);

      const compId = comp.getId();
      if (!originalComponentData[compId]) {
        const originalData = {
          content:
            tagName !== "img"
              ? comp.view?.el?.innerText?.trim() || comp.get("content") || ""
              : "",
          href: comp.getAttributes().href || "",
          alt: tagName === "img" ? comp.getAttributes().alt || "" : "",
          src: tagName === "img" ? comp.getAttributes().src || "" : "",
          title: comp.getAttributes().title || "",
          target: comp.getAttributes().target || "",
        };

        setOriginalComponentData((prev) => ({
          ...prev,
          [compId]: originalData,
        }));
      }

      let content = "";
      if (tagName !== "img") {
        if (comp.get("content")) content = comp.get("content");
        else if (comp.view?.el?.textContent)
          content = comp.view.el.textContent.trim();
        else if (comp.view?.el?.innerText)
          content = comp.view.el.innerText.trim();
        else if (comp.view?.el?.innerHTML) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = comp.view.el.innerHTML;
          content = tempDiv.textContent || tempDiv.innerText || "";
        }
      }

      const href = comp.getAttributes().href || "";
      const alt = tagName === "img" ? comp.getAttributes().alt || "" : "";
      const src =
        tagName === "img" || tagName === "video"
          ? comp.getAttributes().src || ""
          : "";

      console.log("Component Selected Content: ", src);

      setComponentContent(content);
      setComponentHref(href);
      setComponentAlt(alt);
      setComponentSrc(src);
    } else {
      setSelectedComponent(null);
      setComponentContent("");
      setComponentHref("");
      setComponentAlt("");
      setComponentSrc("");
    }
  };

  // Handle image file upload
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file || !selectedComponent || !templateData) return;

    try {
      setIsLoading(true);
      if (!file.type.startsWith("image/")) {
        alert("Please select a valid image file");
        return;
      }
      const maxSizeInMB = 5;
      if (file.size > maxSizeInMB * 1024 * 1024) {
        alert(`File size must be less than ${maxSizeInMB}MB`);
        return;
      }
      const imagePath = await saveImageToTemplateFolder(
        file,
        templateData.templateBaseUrl
      );
      selectedComponent.addAttributes({ src: imagePath });
      if (selectedComponent.view?.el) {
        selectedComponent.view.el.setAttribute("src", imagePath);
      }
      setComponentSrc(imagePath);
      setImageUrlInput(imagePath);
      const compId = selectedComponent.getId();
      setAllChangedComponents((prev) => new Set([...prev, compId]));
      const sharedType = selectedComponent.getAttributes()["data-shared"];
      if (sharedType) {
        setSharedComponentChanges((prev) => ({
          ...prev,
          [sharedType]: {
            ...prev[sharedType],
            src: imagePath,
          },
        }));
      }
      editorRef.current.trigger("component:update", selectedComponent);
      event.target.value = "";
      return imagePath;
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Error uploading image: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle SEO Image File Upload
  const handleSEOImageUpload = async (event) => {
    editorRef.current.select(null);
    const file = event.target.files[0];
    if (!file) return;

    try {
      setIsLoading(true);
      if (!file.type.startsWith("image/")) {
        alert("Please select a valid image file");
        return;
      }
      const maxSizeInMB = 5;
      if (file.size > maxSizeInMB * 1024 * 1024) {
        alert(`File size must be less than ${maxSizeInMB}MB`);
        return;
      }
      const imagePath = await saveImageToTemplateFolder(
        file,
        templateData.templateBaseUrl
      );

      handleSeoChange("ogImage", imagePath);
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Error uploading image: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Image URL
  const handleImageUrl = async (event) => {
    const imageUrl = event.target.value.trim();
    console.log("Video URL:  ", imageUrl);
    console.log("Selected Component: ", selectedComponent);

    if (!imageUrl) {
      if (selectedComponent && selectedComponent.get("tagName") === "img") {
        selectedComponent.addAttributes({ src: "" });
        if (selectedComponent.view?.el) {
          selectedComponent.view.el.setAttribute("src", "");
        }
        setComponentSrc("");

        const compId = selectedComponent.getId();
        setAllChangedComponents((prev) => new Set([...prev, compId]));

        //  Handle shared component changes
        const sharedType = selectedComponent.getAttributes()["data-shared"];
        if (sharedType) {
          setSharedComponentChanges((prev) => ({
            ...prev,
            [sharedType]: {
              ...prev[sharedType],
              src: "",
            },
          }));
        }

        if (editorRef.current) {
          editorRef.current.trigger("component:update", selectedComponent);
        }
      }
      return;
    }

    if (
      !selectedComponent ||
      !["img", "video"].includes(selectedComponent.get("tagName")) ||
      !templateData
    ) {
      console.log("Template Data: ", templateData);
      console.log("No selected component or not an image/video tag");
      return;
    }

    try {
      setIsLoading(true);

      let validatedUrl;
      try {
        validatedUrl = new URL(imageUrl);
        if (!["http:", "https:"].includes(validatedUrl.protocol)) {
          throw new Error("Please enter a valid HTTP or HTTPS URL");
        }
      } catch (urlError) {
        alert("Please enter a valid URL (e.g., https://example.com/image.jpg)");
        return;
      }

      console.log("Validated URL: ", validatedUrl.href);
      console.log("Selected Component Video: ", selectedComponent.view?.el);

      selectedComponent.addAttributes({ src: imageUrl });

      if (selectedComponent.view?.el) {
        selectedComponent.view.el.setAttribute("src", imageUrl);

        // // Setting the src of video tag inside the div tag by grapejs
        // if (selectedComponent.get("tagName") === "video") {
        //   // alert("Selected component is a video element.");
        //   const videoEl = selectedComponent.view?.el;
        //   const videoTag = videoEl.querySelector("video");
        //   console.log("VideoTag: ", videoTag);
        //   if (videoTag) {
        //     videoTag.setAttribute("src", imageUrl);

        //     const EditedData =
        //       JSON.parse(localStorage.getItem("EditedDataJson")) || {};

        //     EditedData.saveData.templateData.pages["index.html"].EditedData = {
        //       EditedData: [
        //         { id: "heroVideo", tag: "video", src: imageUrl },
        //         // ...EditedData.saveData.templateData.pages["index.html"]
        //         //   .EditedData,
        //       ],
        //     };
        //     localStorage.setItem("EditedDataJson", JSON.stringify(EditedData));
        //   }
        //   console.log("Updated Video Tag: ", selectedComponent.view?.el);
        //   console.log("Local Storage After Video URL Change: ", localStorage.getItem("EditedDataJson"));
        // }
      }

      setComponentSrc(imageUrl);

      const compId = selectedComponent.getId();
      setAllChangedComponents((prev) => new Set([...prev, compId]));

      //  Handle shared component changes
      const sharedType = selectedComponent.getAttributes()["data-shared"];
      if (sharedType) {
        setSharedComponentChanges((prev) => ({
          ...prev,
          [sharedType]: {
            ...prev[sharedType],
            src: imageUrl,
          },
        }));
      }

      if (editorRef.current) {
        // console.log(
        //   "Triggering component update for Video URL: ",
        //   allChangedComponents
        // );
        editorRef.current.trigger("component:update", selectedComponent);
      }

      event.target.value = "";
    } catch (error) {
      console.error("Error setting image URL:", error);
      alert("Error setting image URL: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const loadPageContent = async (pagePath) => {
    try {
      // Return modified content if it exists
      if (modifiedPageContents[pagePath]) {
        return modifiedPageContents[pagePath];
      }

      // Load original if not cached
      if (originalPageContents[pagePath]) {
        return originalPageContents[pagePath];
      }

      const curSiteId = getCurSiteId();
      // const sitesResponse = siteData != {} ? siteData : await callApi("/sites/" + curSiteId, "GET", {}, {});

      let sitesResponse = {};
      if (Object.keys(siteData).length !== 0) {
        sitesResponse = siteData;
      } else {
        sitesResponse = await callApi("/sites/" + curSiteId, "GET", {}, {});
        setSiteData(sitesResponse);
      }

      const customDomain = sitesResponse?.respBody?.customDomain || ""; // Custom Domain
      // const customDomain = 'xyz.com'
      console.log("reponsesitedata", sitesResponse);

      const siteSourceTemplateName = sitesResponse?.respBody?.siteSource.replace(
        "template-",
        ""
      );
      console.log("siteSourceName", siteSourceTemplateName);

      const currentTemplateName = templateData.templateName.replaceAll(" ", "");
      const pageName = pagePath.split("/").pop();
      const randomKey = `${Date.now()}-${Math.random()
        .toString(36)
        .substring(2, 15)}`;

      let serverUrl;

      if (siteSourceTemplateName === currentTemplateName) {
        console.log(
          "The source and template name matches",
          siteSourceTemplateName,
          currentTemplateName
        );

        serverUrl =
          customDomain !== ""
            ? `https://www.${customDomain}/${pageName}?turbonckey=${randomKey}`
            : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/${pageName}?turbonckey=${randomKey}`;
      } else {
        console.log(
          "The source and template name doesn't match",
          siteSourceTemplateName,
          currentTemplateName
        );
        serverUrl = `https://${process.env.REACT_APP_HOST_DOMAIN}/templates/${templateData.templateId}/${pageName}?turbonckey=${randomKey}`;
      }

      console.log("serverurl loadpagecontent", serverUrl);

      // Fetch the content

      const response = await fetch(serverUrl);
      // const response = await fetch(`http://100.124.16.42:4000/templates/${pageName}`);

      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status}: ${response.statusText} - Failed to fetch ${pagePath}`
        );
      }

      let html = await response.text();
      console.log("response html: ", html);

      console.log("=== DEBUGGING HTML ===");
      console.log("Response URL:", response.url);
      console.log("Response Status:", response.status);
      console.log(
        "Response Headers:",
        Object.fromEntries(response.headers.entries())
      );
      console.log("HTML First 500 chars:", html.substring(500, 1000));
      console.log("HTML includes your change?:", html.includes("style.css")); // Replace with actual new content
      console.log("======================");

      if (!html || html.trim().length === 0) {
        throw new Error(`Page ${pagePath} returned empty content`);
      }

      const turboSteedHtmlRegex =
        /<div\s+id=["']root["']\s*><\/div>|<noscript>\s*You need to enable JavaScript to run this app\.\s*<\/noscript>/i;

      if (turboSteedHtmlRegex.test(html)) {
        console.log("TurboSteed SPA HTML detected!");
        // const newHtml = await fetch(serverUrl);
        // console.log("Template Api called again")
        // html = newHtml.text()

        return alert("Something Went Wrong Try again");
      }

      if (!html.includes("<") || !html.includes(">")) {
        throw new Error(`Page ${pagePath} does not contain valid HTML`);
      }

      // Extract and set external assets
      const { styles, scripts } = extractExternalStylesAndScripts(html);
      setExtractedAssets((prev) => ({
        ...prev,
        [pagePath]: { styles, scripts },
      }));

      // Process HTML document
      const doc = new DOMParser().parseFromString(html, "text/html");
      const head = doc.querySelector("head");
      TemplateHTML.current = doc

      if (head) {
        const styleLinks = head.querySelectorAll(
          'link[rel="stylesheet"][href]'
        );

        styleLinks.forEach((link) => {
          const href = link.getAttribute("href");
          const fullhref = href.includes("style.css") ? href : "";

          // if (href.includes("https://brazil.turbosteed-staging.com/style.css")) alert('Yes Styles')

          console.log("loaded href for custom style", href);

          const fileName = href.split("/").pop();
          console.log("fileName for href", fileName);

          // const generateRandomKey = (() => {
          //   let lastTimestamp = 0;
          //   let counter = 0;

          //   return function () {
          //     const now = Date.now();

          //     if (now === lastTimestamp) {
          //       counter++;
          //     } else {
          //       lastTimestamp = now;
          //       counter = 0;
          //     }

          //     const randomPart = Math.floor(Math.random() * 100000)
          //       .toString()
          //       .padStart(5, "0");
          //     const counterPart = counter.toString().padStart(3, "0");

          //     return now.toString() + randomPart + counterPart;
          //   };
          // })();

          const randomKey = `${Date.now()}-${Math.random()
            .toString(36)
            .substring(2, 15)}`;
          console.log("the random key ", randomKey);

          if (fileName.startsWith("custom-style.css")) {
            console.log("Matched file starting with custom-style.css");
            const newFileName = "custom-style.css";
            const newHref =
              customDomain !== ""
                ? `https://www.${customDomain}/${newFileName}?turbonckey=${randomKey}`
                : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/${newFileName}?turbonckey=${randomKey}`;
            console.log("newHref for custom-style.css", newHref);
            link.setAttribute("href", newHref);
            return;
          }

          // File is style.css
          if (fileName.includes("style.css")) {
            console.log("Matched file style.css");
            // if (href.includes("/templates/") && templateData?.templateId) {

            const Existing_Styles_regex =
              /^https:\/\/[a-zA-Z0-9-]+\.turbosteed-staging\.com\/style\.css\?turbonckey=.*$/;
            console.log(
              "Checking href before callng the style.css: ",
              fullhref
            );

            if (siteSourceTemplateName === "unknown") {
              console.log("IF condition satisfied the siteSourceName");
              const newHref = `https://www.${process.env.REACT_APP_HOST_DOMAIN}/templates/${templateData.templateId}/${fileName}`;

              console.log("newHref for style.css", newHref);

              link.setAttribute("href", newHref);
            }

            if (customDomain !== "") {
              const newHref = `https://www.${customDomain}/style.css?turbonckey=${randomKey}`;
              console.log("newHref for custom domain style.css", newHref);
              link.setAttribute("href", newHref);
              return;
            }

            if (Existing_Styles_regex.test(fullhref)) {
              // Any existing site based on the template should have  a valid
              // style.css file in its folder. If there is not  one, then create
              // it.

              const newHref = `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/style.css?turbonckey=${randomKey}`;
              // const relativehref = `/style.css?turbonckey=${randomKey}`;

              link.setAttribute("href", newHref);
            } else {
              console.log("IF condition not satisfied");
              const newHref = `https://www.${process.env.REACT_APP_HOST_DOMAIN}/templates/${templateData.templateId}/${fileName}`;

              console.log("newHref for style.css", newHref);

              link.setAttribute("href", newHref);
            }

            return;
          }
        });
      }

      // Reconstruct HTML with DOCTYPE
      html = "<!DOCTYPE html>\n" + doc.documentElement.outerHTML;
      console.log("htmlnew", html);

      // Cache original content
      setOriginalPageContents((prev) => ({ ...prev, [pagePath]: html }));

      return html;
    } catch (error) {
      console.error(`Error loading page:`, error);
      throw error;
    }
  };

  const captureCurrentPageState = useCallback(() => {
    if (!editorRef.current || selectedPageIndex < 0 || !templateData) return;

    try {
      const currentPage =
        templateData.templateFiles.templatePageURLs[selectedPageIndex];
      const canvasDoc = editorRef.current.Canvas.getDocument();

      if (canvasDoc) {
        // Apply current themes before capturing
        if (editableTheme && Object.keys(editableTheme).length > 0) {
          Object.entries(editableTheme).forEach(([property, value]) => {
            // canvasDoc.documentElement.style.setProperty(property, value, 'important');
          });
        }

        if (editableFonts && Object.keys(editableFonts).length > 0) {
          Object.entries(editableFonts).forEach(([property, value]) => {
            // canvasDoc.documentElement.style.setProperty(property, value, 'important');
          });
        }

        const modifiedHtml = canvasDoc.documentElement.outerHTML;
        // console.log("Modified HTML: ", modifiedHtml)
        setModifiedPageContents((prev) => ({
          ...prev,
          [currentPage]: modifiedHtml,
        }));

        if (allChangedComponents.size > 0) {
          setHasUnsavedChanges(true);
        }
      }
    } catch (error) {
      console.error("Error capturing page state:", error);
    }
  }, [
    editorRef,
    selectedPageIndex,
    templateData,
    allChangedComponents.size,
    editableTheme,
    editableFonts,
  ]);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        let apiBaseURL = `https://${process.env.REACT_APP_HOST_URL}/templates`;
        // if (process.env.REACT_APP_TURBO_ENV === "local") {
        //   apiBaseURL = 'https://${process.env.REACT_APP_HOST_URL}/templates';
        // } else if (process.env.REACT_APP_TURBO_ENV === 'dev') {
        //   apiBaseURL = 'https://turbosteed-staging.com/templates';
        // } else {
        //   apiBaseURL = 'https://turbosteed.com/templates';
        // }

        const fetchTemplateData = `${apiBaseURL}/${templateId}/`;
        const response = await fetch(fetchTemplateData, {
          method: "GET",
          headers: {
            "Content-Type": "application/json,text/html",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch templates");
        }

        const data = await response.json();
        console.log("TemplateData", data);
        if (data) {
          setTemplateData(data);
          AiRequestBodyRef.current.template_type = data.templateId;
          setSelectedPageIndex(0);
          // if (existingTemplateJSON && Object.keys(existingTemplateJSON).length > 0) {
          //   populateEditorStateFromJson(existingTemplateJSON);
          //   // console.log("Populated editor state from existing JSON");
          // }
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };

    fetchTemplates();
  }, [templateId, existingTemplateJSON]);

  useEffect(() => {
    if (templateData && selectedPageIndex >= 0) {
      const currentPage =
        templateData.templateFiles.templatePageURLs[selectedPageIndex];
      const existingSeoData = seoPerPage[currentPage];
      console.log("Loading SEO data for page:", currentPage, existingSeoData);
      setSeoData(existingSeoData);

      if (!originalSeoData[currentPage]) {
        setOriginalSeoData((prev) => ({
          ...prev,
          [currentPage]: existingSeoData,
        }));
      }

      const pageName = currentPage.split('/').pop();
      const existingPageCustomCode = existingTemplateJSON.current?.templateData?.pages[pageName]?.customCode;
      const existingGlobalCustomCode = existingTemplateJSON.current?.templateData?.globalCustomCode;

      // Initialize global code (once)
      if (!customCodeInitialized.current) {
        customCodeInitialized.current = true;
        // Handle backwards compatibility: migrate old scope='all' to globalCustomCode
        if (existingPageCustomCode?.scope === 'all' && existingPageCustomCode?.head_js) {
          setCustomCodeGlobal({ head_js: existingPageCustomCode.head_js });
        } else if (existingGlobalCustomCode?.head_js) {
          setCustomCodeGlobal({ head_js: existingGlobalCustomCode.head_js });
        }
      }

      // Load per-page JS (skip if old format had scope='all' since that was global)
      const existingJs =
        customCodePerPage[currentPage]?.head_js ??
        (existingPageCustomCode?.scope !== 'all' ? existingPageCustomCode?.head_js : '') ??
        '';
      setCustomCode({ head_js: existingJs });
    }
  }, [selectedPageIndex, templateData]);

  const updateSeoForCurrentPage = useCallback(
    (newSeoData) => {
      if (templateData && selectedPageIndex >= 0) {
        const currentPage =
          templateData.templateFiles.templatePageURLs[selectedPageIndex];
        setSeoPerPage((prev) => ({
          ...prev,
          [currentPage]: newSeoData,
        }));
      }
    },
    [templateData, selectedPageIndex]
  );

  const handleSeoChange = useCallback(
    (field, value) => {
      console.log(`SEO ${field} changed to: ${value}`);
      const newSeoData = { ...seoData, [field]: value };
      setSeoData(newSeoData);
      updateSeoForCurrentPage(newSeoData);
    },
    [seoData, updateSeoForCurrentPage]
  );

  const handleCustomCodeChange = useCallback(
    (value) => {
      const newCode = { head_js: value };
      setCustomCode(newCode);
      if (templateData && selectedPageIndex >= 0) {
        const currentPage = templateData.templateFiles.templatePageURLs[selectedPageIndex];
        setCustomCodePerPage((prev) => ({ ...prev, [currentPage]: newCode }));
      }
      setHasUnsavedChanges(true);
    },
    [templateData, selectedPageIndex]
  );

  const handleGlobalCodeChange = useCallback((value) => {
    setCustomCodeGlobal({ head_js: value });
    setHasUnsavedChanges(true);
  }, []);

  const handleOpenCustomCode = useCallback(async () => {
    setShowCustomCodeEditor(true);
    const siteSourceTemplateName = siteData?.respBody?.siteSource?.replace("template-", "");
    const currentTemplateName = templateData?.templateName?.replaceAll(" ", "");
    if (siteSourceTemplateName && currentTemplateName && siteSourceTemplateName !== currentTemplateName) {
      return;
    }
    setCustomCode({ head_js: '' });
    setCustomCodeGlobal({ head_js: '' });
    setCustomCodeFetching(true);
    try {
      const rc = await callApi(`/sites/${getCurSiteId()}/getTemplateData`, "GET", {}, {});
      if (!rc?.respBody) return;
      const templateDataFromApi = rc.respBody?.message?.lastSavedData?.editedDataJson?.templateData?.templateData;
      const pageName = templateData?.templateFiles?.templatePageURLs?.[selectedPageIndex]?.split("/").pop();
      const savedPageCode = templateDataFromApi?.pages?.[pageName]?.customCode;
      const savedGlobalCode = templateDataFromApi?.globalCustomCode;

      // Load global JS
      if (savedGlobalCode?.head_js !== undefined) {
        setCustomCodeGlobal({ head_js: savedGlobalCode.head_js });
      } else if (savedPageCode?.scope === 'all' && savedPageCode?.head_js) {
        // Backwards compatibility: old format had global JS stored per-page with scope='all'
        setCustomCodeGlobal({ head_js: savedPageCode.head_js });
      }

      // Load per-page JS (skip if old format had scope='all')
      if (savedPageCode?.head_js !== undefined && savedPageCode?.scope !== 'all') {
        setCustomCode({ head_js: savedPageCode.head_js });
      }
    } catch (e) {
      console.error("Failed to fetch saved custom code:", e);
    } finally {
      setCustomCodeFetching(false);
    }
  }, [templateData, selectedPageIndex, siteData]);

  useEffect(() => {
    if (!templateData || !containerRef.current || selectedPageIndex < 0) return;
    const loadEditor = async () => {
      setIsLoading(true);
      setLoadError(null);
      setSelectedComponent(null);
      setComponentContent("");
      setComponentHref("");
      setComponentAlt("");
      setComponentSrc("");

      setLoading(true);

      if (editorRef.current) {
        try {
          editorRef.current.destroy();
        } catch { }
        editorRef.current = null;
      }
      containerRef.current.innerHTML = "";

      try {
        const selectedPage =
          templateData.templateFiles.templatePageURLs[selectedPageIndex];

        let html = await loadPageContent(selectedPage);

        // Store original content if first time loading
        if (!originalPageContents[selectedPage]) {
          setOriginalPageContents((prev) => ({
            ...prev,
            [selectedPage]: html,
          }));
        }

        const templateBase = templateData.templateBaseUrl;
        if (!templateBase) {
          throw new Error("Template base path is missing");
        }

        html = patchImagePaths(html, templateBase);

        //  Apply shared component changes by completely replacing the elements (preserves ALL attributes and styles)
        if (Object.keys(sharedComponentChanges).length > 0) {
          const doc = new DOMParser().parseFromString(html, "text/html");

          Object.entries(sharedComponentChanges).forEach(
            ([sharedId, sharedHTML]) => {
              const sharedElements = doc.querySelectorAll(
                `[data-shared="${sharedId}"]`
              );

              sharedElements.forEach((element) => {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = sharedHTML;
                const newElement = tempDiv.firstElementChild;

                if (newElement) {
                  element.parentNode.replaceChild(newElement, element);
                }
              });
            }
          );

          html = doc.documentElement.outerHTML;
        }

        // Extract and apply external assets to the editor
        const { styles, scripts } = extractExternalStylesAndScripts(html);
        const editor = grapesjs.init({
          container: containerRef.current,
          height: "100%",
          width: "100%",
          fromElement: false,
          storageManager: false,
          panels: { defaults: [] },
          blockManager: { disable: true },
          selectorManager: { componentFirst: true },
          styleManager: { clearProperties: true },
          layerManager: { showWrapper: false },
          deviceManager: {
            devices: [
              {
                name: "Desktop",
                width: "",
                widthMedia: null,
              },
              {
                name: "Tablet",
                width: "768px",
                widthMedia: "992px",
              },
              {
                name: "Mobile",
                width: "320px",
                widthMedia: "768px",
              },
            ],
          },
          canvas: {
            styles: [
              // 'https://www.turbosteed-staging.com/templates/GymTemplate/styles.css?t=' + Date.now(),
              // 'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css',
              // ...styles.map(style => `${templateData.templateBaseUrl}${style.href}?t=${Date.now()}`),
              // 'style.css',
            ],
            scripts: [
              // ...scripts.filter(script => !script.isInline).map(script => script.src),
              // 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js'
            ],

            customBadgeLabel: false,
            frameStyle: `
              body {
                margin: 0;
                padding: 0;
                overflow-y: auto !important; 
                height: auto !important;
              }
            `,
          },
        });
        editor.setComponents(html);
        restrictDivSelection(editor);
        // Add inline scripts to the canvas after initialization
        setTimeout(() => {
          const canvasDoc = editor.Canvas.getDocument();
          const canvasWindow = editor.Canvas.getWindow();

          if (canvasDoc && canvasWindow) {
            scripts
              .filter((script) => script.isInline)
              .forEach((script) => {
                const scriptEl = canvasDoc.createElement("script");
                scriptEl.textContent = script.content;
                canvasDoc.head.appendChild(scriptEl);
              });
          }
        }, 500);

        setTimeout(() => {
          setIsLoading(false);
          reinitializeAnimations();
          applyStoredThemesToNewPage();
        }, 400);
        //  Find shared component and preserve complete element structure
        const findSharedAncestor = (comp) => {
          let current = comp;
          while (current) {
            const sharedId = current.getAttributes()["data-shared"];
            if (sharedId) return { comp: current, sharedId };
            current = current.parent();
          }
          return null;
        };

        //  Complete shared component update handler that preserves ALL attributes and styles
        editor.on("component:update", (model) => {
          const sharedInfo = findSharedAncestor(model);
          if (!sharedInfo) return;
          const { comp: sharedComp, sharedId } = sharedInfo;
          const completeHTML = sharedComp.toHTML();
          setSharedComponentChanges((prev) => ({
            ...prev,
            [sharedId]: completeHTML,
          }));
          const pagesCopy = { ...modifiedPageContents };
          templateData.templateFiles.templatePageURLs.forEach((page, idx) => {
            if (idx === selectedPageIndex) return;

            const srcHtml = pagesCopy[page] || originalPageContents[page];
            if (!srcHtml) return;

            const doc = new DOMParser().parseFromString(srcHtml, "text/html");
            const targets = doc.querySelectorAll(`[data-shared="${sharedId}"]`);

            targets.forEach((target) => {
              const tempContainer = document.createElement("div");
              tempContainer.innerHTML = completeHTML;
              const updatedElement = tempContainer.firstElementChild;

              if (updatedElement) {
                target.parentNode.replaceChild(updatedElement, target);
              }
            });

            pagesCopy[page] = doc.documentElement.outerHTML;
          });

          setModifiedPageContents(pagesCopy);
        });

        const setComponentsDraggableFalse = (component) => {
          component.set("draggable", false);
          component
            .components()
            .forEach((child) => setComponentsDraggableFalse(child));
        };
        setComponentsDraggableFalse(editor.getWrapper());
        setTimeout(() => {
          const canvasDoc = editor.Canvas.getDocument();
          if (canvasDoc) {
            // Check for existing favicon
            const faviconLink = canvasDoc.querySelector('link[rel*="icon"]');
            if (faviconLink) {
              const faviconHref = faviconLink.getAttribute("href");
              setCurrentFavicon(faviconHref);
              setFaviconUrlInput(faviconHref);

              // Ensure it's marked as a shared component
              if (!faviconLink.getAttribute("data-shared")) {
                faviconLink.setAttribute("data-shared", "favicon");
              }

              // Add to original component data
              setOriginalComponentData((prev) => ({
                ...prev,
                favicon: {
                  src: faviconHref,
                  content: "",
                  href: "",
                  alt: "",
                },
              }));
            }
          }
        }, 500);
        setTimeout(() => {
          try {
            const canvasDoc = editor.Canvas.getDocument();
            const footer = canvasDoc.querySelector(
              "footer, .footer, .footer-brand"
            );
            if (footer) {
              footer.style.display = "block";
              footer.style.visibility = "visible";
              footer.style.opacity = "1";
              footer.style.position = "relative";
              footer.style.zIndex = "1";
            }
          } catch (error) {
            console.log("Footer adjustment error:", error);
          }
        }, 300);

        // Setup asset manager (excluding favicon)
        setTimeout(() => {
          try {
            const existingImages = extractImagesFromHtml(html);
            const assetManager = editor.AssetManager;
            assetManager.getAll().reset();
            if (
              templateData.templateAssets &&
              Array.isArray(templateData.templateAssets)
            ) {
              templateData.templateAssets.forEach((asset) => {
                if (
                  asset &&
                  typeof asset === "string" &&
                  !asset.includes("favicon")
                ) {
                  assetManager.add({
                    src: asset,
                    name: asset.split("/").pop() || "Asset",
                    type: "image",
                  });
                }
              });
            }
            existingImages.forEach((img) => {
              if (img.src && img.name && !img.src.includes("favicon")) {
                assetManager.add({
                  ...img,
                  type: "image",
                });
              }
            });
          } catch { }
        }, 200);

        editor.on("component:selected", handleComponentSelected);

        editor.on("device:select", (device) => {
          // console.log("Device changed via GrapesJS:", device.get("name"));
          setDevice(device.get("name"));
        });

        editor.on("component:update", (component) => {
          console.log("Component updated: ", component);
          const compId = component.getId();
          setAllChangedComponents((prev) => new Set([...prev, compId]));
          setHasUnsavedChanges(true);
          clearTimeout(window.stateTimer);
          window.stateTimer = setTimeout(() => {
            captureCurrentPageState();
          }, 500);
        });

        editor.on("component:deselected", () => {
          setSelectedComponent(null);
          setComponentContent("");
          setComponentHref("");
          setComponentAlt("");
          setComponentSrc("");
        });

        editor.on("component:add", (comp) => {
          if (!["text", "textnode"].includes(comp.get("type"))) comp.remove();
        });

        editor.on("component:remove", (comp) => {
          if (["wrapper", "body"].includes(comp.get("type")))
            editor.UndoManager.undo();
        });

        editor.BlockManager.getAll().reset();

        setTimeout(() => {
          setIsLoading(false);
          reinitializeAnimations();
        }, 400);

        editorRef.current = editor;
      } catch (error) {
        console.error("Error loading page into editor:", error);
        setLoadError(`Failed to load page: ${error.message}`);
        setIsLoading(false);
      } finally {
        setLoading(false);
      }
    };

    loadEditor();
  }, [selectedPageIndex, templateData]);

  const restrictDivSelection = (editor) => {
    // Prevent selection of div, section, and other container elements
    editor.on("component:select", (model) => {
      const tagName = model.get("tagName").toLowerCase();
      setActiveTab("properties");
      const nonSelectableTags = [
        "div",
        "li",
        "i",
        "section",
        "main",
        "article",
        "aside",
        "nav",
        "header",
        "footer",
        "body",
        "html",
      ];

      if (nonSelectableTags.includes(tagName)) {
        // Deselect the container and try to select a child element instead
        editor.select();

        // Try to find a selectable child element
        const children = model.components();
        if (children.length > 0) {
          const selectableChild = children.find((child) => {
            const childTag = child.get("tagName").toLowerCase();
            return (
              !nonSelectableTags.includes(childTag) &&
              (["text", "link", "image", "button", "video"].includes(
                child.get("type")
              ) ||
                [
                  "a",
                  "button",
                  "span",
                  "p",
                  "h2",
                  "h3",
                  "h4",
                  "h5",
                  "h6",
                  "img",
                  "video",
                ].includes(childTag))
            );
          });

          console.log("Child Component: ", selectableChild);

          if (selectableChild) {
            console.log("Selecting child component instead:", selectableChild);
            editor.select(selectableChild);
          }
        }
      }
    });

    // Also restrict what can be selected via traits
    editor.TraitManager.addType("restricted-select", {
      noLabel: true,
      createInput() {
        return document.createElement("div");
      },
    });
  };

  // useEffect(() => {
  //       const editor = editorRef.current;
  //       console.log('Wrapper:', editor.getWrapper());
  //   }, []);

  // Track content changes

  useEffect(() => {
    if (selectedComponent && editorRef.current && !isLoading) {
      const compId = selectedComponent.getId();
      const currentContent =
        selectedComponent.get("content") ||
        selectedComponent.view?.el?.textContent ||
        selectedComponent.view?.el?.innerText ||
        "";

      if (componentContent !== currentContent.trim()) {
        try {
          selectedComponent.set("content", componentContent);
          if (selectedComponent.view?.el)
            selectedComponent.view.el.textContent = componentContent;

          editorRef.current.trigger("component:update", selectedComponent);
          setAllChangedComponents((prev) => new Set([...prev, compId]));
        } catch { }
      }
    }
  }, [componentContent, selectedComponent, isLoading]);

  // Track href changes
  useEffect(() => {
    if (selectedComponent && editorRef.current && !isLoading) {
      const compId = selectedComponent.getId();
      const currentHref = selectedComponent.getAttributes().href || "";

      if (componentHref !== currentHref) {
        try {
          selectedComponent.addAttributes({ href: componentHref });
          if (selectedComponent.view?.el) {
            if (componentHref)
              selectedComponent.view.el.setAttribute("href", componentHref);
            else selectedComponent.view.el.removeAttribute("href");
          }

          editorRef.current.trigger("component:update", selectedComponent);
          setAllChangedComponents((prev) => new Set([...prev, compId]));
        } catch { }
      }
    }
  }, [componentHref, selectedComponent, isLoading]);

  // Track alt text changes
  useEffect(() => {
    if (
      selectedComponent &&
      editorRef.current &&
      !isLoading &&
      selectedComponent.get("tagName") === "img"
    ) {
      const compId = selectedComponent.getId();
      const currentAlt = selectedComponent.getAttributes().alt || "";

      if (componentAlt !== currentAlt) {
        try {
          selectedComponent.addAttributes({ alt: componentAlt });
          if (selectedComponent.view?.el) {
            if (componentAlt)
              selectedComponent.view.el.setAttribute("alt", componentAlt);
            else selectedComponent.view.el.removeAttribute("alt");
          }

          editorRef.current.trigger("component:update", selectedComponent);
          setAllChangedComponents((prev) => new Set([...prev, compId]));
        } catch { }
      }
    }
  }, [componentAlt, selectedComponent, isLoading]);

  // Track image src changes
  useEffect(() => {
    if (
      selectedComponent &&
      editorRef.current &&
      !isLoading &&
      !["img", "video"].includes(selectedComponent.get("tagName"))
    ) {
      const compId = selectedComponent.getId();
      const currentSrc = selectedComponent.getAttributes().src || "";
      if (componentSrc !== currentSrc) {
        try {
          selectedComponent.addAttributes({ src: componentSrc });
          if (selectedComponent.view?.el) {
            selectedComponent.view.el.setAttribute("src", componentSrc);
          }

          console.log("Triggering component update for SRC change", currentSrc);
          editorRef.current.trigger("component:update", selectedComponent);
          setAllChangedComponents((prev) => new Set([...prev, compId]));
        } catch { }
      }
    }
  }, [componentSrc, selectedComponent, isLoading]);

  // useEffect(() => {
  //   const handleBeforeUnload = (e) => {
  //     e.preventDefault();
  //     e.returnValue = '';
  //   };

  //   const handlePopState = (e) => {
  //     e.preventDefault();
  //     const confirmLeave = window.confirm(
  //       'If you go back, your changes will be lost forever. Are you sure?'
  //     );
  //     if (confirmLeave) {
  //       // Allow back navigation
  //       window.history.back(); // allow the back action
  //     } else {
  //       // Push current path again to block navigation
  //       window.history.pushState(null, '', window.location.pathname);
  //     }
  //   };

  //   // Warn on refresh/close
  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   // Intercept browser back button
  //   window.history.pushState(null, '', window.location.pathname);
  //   window.addEventListener('popstate', handlePopState);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //     window.removeEventListener('popstate', handlePopState);
  //   };
  // }, []);

  const handleFetchHtmlData = async () => {
    const saveDataJson = JSON.parse(localStorage.getItem("EditedDataJson"));
    const sharedComponentsHTML = JSON.parse(
      localStorage.getItem("sharedComponentsHTML") || "{}"
    );

    console.log("SaveDataJson", saveDataJson);
    console.log("Shared Components HTML to apply:", sharedComponentsHTML);

    try {
      const htmlObject = {};
      const allTemplateHtmlUrl = templateData.templateFiles.templatePageURLs;
      console.log("All template HTML URLs:", allTemplateHtmlUrl);

      const consistentTurboncKey =
        Date.now().toString() + Math.floor(Math.random() * 100000);
      const baseUrl = templateData.templateBaseUrl;
      const contactFormConfig = saveDataJson.saveData.contactForm || null;

      console.log("Save Data:", saveDataJson.saveData);

      for (
        let pageIndex = 0;
        pageIndex < allTemplateHtmlUrl.length;
        pageIndex++
      ) {
        const pagePath = allTemplateHtmlUrl[pageIndex];
        const fileName = pagePath.split("/").pop();

        console.log(`Loading fresh HTML for ${fileName} from server...`);

        try {
          const curSiteId = getCurSiteId();
          let sitesResponse = {};
          if (Object.keys(siteData).length !== 0) {
            sitesResponse = siteData;
          } else {
            sitesResponse = await callApi("/sites/" + curSiteId, "GET", {}, {});
            setSiteData(sitesResponse);
          }
          const customDomain = sitesResponse?.respBody?.customDomain || ""; // Custom Domain
          // const customDomain = 'xyz.com'
          const siteSourceTemplateName =
            sitesResponse?.respBody?.siteSource.replace("template-", "");
          const currentTemplateName = templateData.templateName.replaceAll(
            " ",
            ""
          );

          let serverUrl;
          if (siteSourceTemplateName === currentTemplateName) {
            serverUrl =
              customDomain !== ""
                ? `https://www.${customDomain}/${fileName}?turbonckey=${consistentTurboncKey}`
                : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/${fileName}?turbonckey=${consistentTurboncKey}`;
          } else {
            serverUrl = `https://${process.env.REACT_APP_HOST_DOMAIN}/templates/${templateData.templateId}/${fileName}?turbonckey=${consistentTurboncKey}`;
          }

          console.log("handleFetchHtmlData serverUrl: ", serverUrl);
          const response = await fetch(serverUrl);
          // const response = await fetch(`http://100.124.16.42:4000/templates/${fileName}`)
          if (!response.ok) {
            throw new Error(
              `HTTP ${response.status}: Failed to fetch ${fileName}`
            );
          }

          let pageHtml = await response.text();

          if (!pageHtml || !pageHtml.includes("<")) {
            throw new Error(`Invalid HTML for ${fileName}`);
          }

          console.log(
            `✓ Loaded fresh HTML for ${fileName} (${pageHtml.length} chars)`
          );

          const doc = new DOMParser().parseFromString(pageHtml, "text/html");

          const head = doc.querySelector("head");
          if (head) {
            const styleLinks = head.querySelectorAll(
              'link[rel="stylesheet"][href]'
            );
            styleLinks.forEach((link) => {
              const href = link.getAttribute("href");
              const hrefFileName = href.split("/").pop().split("?")[0];

              if (hrefFileName.startsWith("custom-style.css")) {
                const newHref =
                  customDomain !== ""
                    ? `https://www.${customDomain}/custom-style.css?turbonckey=${consistentTurboncKey}`
                    : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/custom-style.css?turbonckey=${consistentTurboncKey}`;
                console.log(
                  "New Href for custom-style.css in handleFetchHTML DATA: ",
                  newHref
                );
                link.setAttribute("href", newHref);
              } else if (hrefFileName === "style.css") {
                const newHref =
                  customDomain !== ""
                    ? `https://www.${customDomain}/style.css?turbonckey=${consistentTurboncKey}`
                    : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/${hrefFileName}?turbonckey=${consistentTurboncKey}`;
                console.log(
                  "New Href for style.css in handleFetchHTML DATA: ",
                  newHref
                );
                link.setAttribute("href", newHref);
              }
            });
          }

          console.log(`Applying shared components to ${fileName}...`);
          if (Object.keys(sharedComponentsHTML).length > 0) {
            Object.entries(sharedComponentsHTML).forEach(
              ([sharedId, sharedHTML]) => {
                if (sharedId === "favicon") {
                  if (Array.isArray(sharedHTML)) {
                    sharedHTML.forEach((faviconEdit) => {
                      if (faviconEdit.imageUrl || faviconEdit.href) {
                        let faviconLink =
                          doc.querySelector('link[rel*="icon"]');
                        if (!faviconLink) {
                          faviconLink = doc.createElement("link");
                          faviconLink.setAttribute("rel", "icon");
                          doc.head.appendChild(faviconLink);
                        }
                        const faviconUrl =
                          faviconEdit.imageUrl || faviconEdit.href;
                        faviconLink.setAttribute("href", faviconUrl);
                        console.log(`✓ Applied favicon to ${fileName}`);
                      }
                    });
                  }
                } else if (
                  typeof sharedHTML === "string" &&
                  sharedHTML.trim().startsWith("<")
                ) {
                  const sharedElements = doc.querySelectorAll(
                    `[data-shared="${sharedId}"]`
                  );
                  console.log("SharedID: ", sharedId);
                  if (sharedElements.length > 0) {
                    sharedElements.forEach((element, index) => {
                      const tempDiv = document.createElement("div");
                      tempDiv.innerHTML = sharedHTML;
                      const newElement = tempDiv.firstElementChild;
                      if (newElement && element.parentNode) {
                        element.parentNode.replaceChild(
                          newElement.cloneNode(true),
                          element
                        );
                        console.log(`✓ Replaced ${sharedId} in ${fileName}`);
                      }
                    });
                  }
                }
              }
            );
          }

          const pageData = saveDataJson.saveData.templateData.pages[fileName];
          if (
            pageData &&
            pageData.EditedData &&
            pageData.EditedData.length > 0
          ) {
            console.log(
              `Applying ${pageData.EditedData.length} edits to ${fileName}`
            );
            console.log("Page Data After Save: ", pageData);
            pageData.EditedData.forEach((edit) => {
              const element = doc.getElementById(edit.id);

              // if (edit.id === "h1-1") console.log("ID Exist And Tagname is: ", element)

              if (element) {
                if (edit.content !== undefined && edit.tag !== "img") {
                  element.innerHTML = edit.content;
                }

                if (edit.imageUrl !== undefined) {
                  const imgUrl = edit.imageUrl;
                  if (
                    imgUrl.startsWith("http://") ||
                    imgUrl.startsWith("https://")
                  ) {
                    element.setAttribute("src", imgUrl);
                  } else {
                    const fullUrl = imgUrl.startsWith("/")
                      ? `${baseUrl}${imgUrl}`
                      : `${baseUrl}/${imgUrl}`;
                    element.setAttribute("src", fullUrl);
                  }
                }
                if (edit.imageAltText !== undefined) {
                  element.setAttribute("alt", edit.imageAltText);
                }
                if (edit.linkDetails !== undefined) {
                  element.setAttribute("href", edit.linkDetails);
                }
              }
            });
          }

          const allImages = doc.querySelectorAll("img[src]");
          allImages.forEach((img) => {
            const src = img.getAttribute("src");
            if (
              src &&
              !src.startsWith("http://") &&
              !src.startsWith("https://") &&
              !src.startsWith("//")
            ) {
              const fullUrl = src.startsWith("/")
                ? `${baseUrl}${src}`
                : `${baseUrl}${src}`;
              img.setAttribute("src", fullUrl);
            }
          });

          const allVideos = doc.querySelectorAll("video[src]");
          allVideos.forEach((video) => {
            const src = video.getAttribute("src");
            if (
              src &&
              !src.startsWith("http://") &&
              !src.startsWith("https://") &&
              !src.startsWith("//")
            ) {
              const fullUrl = src.startsWith("/")
                ? `${baseUrl}${src}`
                : `${baseUrl}${src}`;
              video.setAttribute("src", fullUrl);
            }
          });

          console.log("contactFormConfig: ", contactFormConfig);
          const form = doc.querySelector("#contactForm");
          console.log("formID: ", form);
          if (contactFormConfig && form) {
            const scripts = doc.querySelectorAll("script");
            console.log(`Scripts Found: `, scripts);
            let contactFormScriptFound = false;

            // Check if config script already exists to avoid duplicates
            const configAlreadyExists = Array.from(scripts).some((script) => {
              const content = script.textContent || '';
              return content.includes('const accountId =') &&
                     content.includes('const accountApiToken =') &&
                     content.includes('const apiUrl =');
            });

            if (!configAlreadyExists) {
              scripts.forEach((script) => {
                const scriptContent =
                  script.textContent || script.innerHTML || script.src;
                console.log("Script Content: ", scriptContent);
                if (
                  scriptContent.includes("TSCFSubmit") ||
                  scriptContent.includes("submitTSCFForm")
                ) {
                  contactFormScriptFound = true;
                  const configScript = doc.createElement("script");
                  configScript.textContent = `
                const accountId = "${contactFormConfig.accountId}";
                const accountApiToken = "${contactFormConfig.accountApiToken}";
                const apiUrl = "${contactFormConfig.apiUrl}";
              `;
                  script.parentNode.insertBefore(configScript, script);
                  console.log(`✓ Injected contact form config into ${fileName}`);
                }
              });

              if (!contactFormScriptFound) {
                console.warn(`Contact form script not found in ${fileName}`);
              }
            } else {
              console.log(`✓ Contact form config already exists in ${fileName}, skipping injection`);
            }
          }

          if (pageData && pageData.SEO && pageData.SEO.length > 0) {
            const seoData = pageData.SEO[0];

            // SEO Title
            if (seoData.meta_title) {
              let titleElement = doc.querySelector("title");
              if (!titleElement) {
                titleElement = doc.createElement("title");
                doc.head.appendChild(titleElement);
              }
              titleElement.textContent = seoData.meta_title;
            }

            // SEO meta_description
            if (seoData.meta_description) {
              let metaDesc = doc.querySelector('meta[name="description"]');
              if (!metaDesc) {
                metaDesc = doc.createElement("meta");
                metaDesc.setAttribute("name", "description");
                doc.head.appendChild(metaDesc);
              }
              metaDesc.setAttribute("content", seoData.meta_description);
            }

            // SEO MetaTags
            if (seoData.metaTags) {
              let metaKeywords = doc.querySelector('meta[name="keywords"]');
              if (!metaKeywords) {
                metaKeywords = doc.createElement("meta");
                metaKeywords.setAttribute("name", "keywords");
                doc.head.appendChild(metaKeywords);
              }
              metaKeywords.setAttribute("content", seoData.metaTags);
            }

            // SEO Canonical URL And Og:URL
            if (seoData.canonicalUrl) {
              let linkCanonicalUrl = doc.querySelector('link[rel="canonical"]');
              console.log("linkCanonicalUrl: ", linkCanonicalUrl);
              if (!linkCanonicalUrl) {
                linkCanonicalUrl = doc.createElement("link");
                linkCanonicalUrl.setAttribute("rel", "canonical");
                doc.head.appendChild(linkCanonicalUrl);
              }
              linkCanonicalUrl.setAttribute("href", seoData.canonicalUrl);

              let metaOgUrl = doc.querySelector('meta[property="og:url"]');
              if (!metaOgUrl) {
                metaOgUrl = doc.createElement("meta");
                metaOgUrl.setAttribute("property", "og:url");
                doc.head.appendChild(metaOgUrl);
              }
              metaOgUrl.setAttribute("content", seoData.ogUrl);
            }

            // SEO Robots
            // if (seoData.robots) {
            //   let robot = doc.querySelector('meta[name="robots"]');
            //   if (!robot) {
            //     robot = doc.createElement("meta");
            //     robot.setAttribute("name", "robots");
            //     doc.head.appendChild(robot);
            //   }
            //   robot.setAttribute("content", seoData.robots);
            // }

            // SEO ogType
            if (seoData.ogType) {
              let metaOgType = doc.querySelector('meta[property="og:type"]');
              if (!metaOgType) {
                metaOgType = doc.createElement("meta");
                metaOgType.setAttribute("property", "og:type");
                doc.head.appendChild(metaOgType);
              }
              metaOgType.setAttribute("content", seoData.ogType);
            }

            //SEO og_title and twitterTitle
            if (seoData.og_title) {
              let metaOgTitle = doc.querySelector('meta[property="og:title"]');
              if (!metaOgTitle) {
                metaOgTitle = doc.createElement("meta");
                metaOgTitle.setAttribute("property", "og:title");
                doc.head.appendChild(metaOgTitle);
              }
              metaOgTitle.setAttribute("content", seoData.og_title);

              let metaTwitterTitle = doc.querySelector(
                'meta[name="twitter:title"]'
              );
              if (!metaTwitterTitle) {
                metaTwitterTitle = doc.createElement("meta");
                metaTwitterTitle.setAttribute("name", "twitter:title");
                doc.head.appendChild(metaTwitterTitle);
              }
              metaTwitterTitle.setAttribute("content", seoData.og_title);
            }

            // SEO og_description and twitterDescription
            if (seoData.og_description) {
              let metaOgDescription = doc.querySelector(
                'meta[property="og:description"]'
              );
              if (!metaOgDescription) {
                metaOgDescription = doc.createElement("meta");
                metaOgDescription.setAttribute("property", "og:description");
                doc.head.appendChild(metaOgDescription);
              }
              metaOgDescription.setAttribute("content", seoData.og_description);

              let metaTwitterDescription = doc.querySelector(
                'meta[name="twitter:description"]'
              );
              if (!metaTwitterDescription) {
                metaTwitterDescription = doc.createElement("meta");
                metaTwitterDescription.setAttribute(
                  "name",
                  "twitter:description"
                );
                doc.head.appendChild(metaTwitterDescription);
              }
              metaTwitterDescription.setAttribute(
                "content",
                seoData.og_description
              );
            }

            // SEO ogImage and twitterImage
            if (seoData.ogImage) {
              let metaOgImage = doc.querySelector('meta[property="og:image"]');
              console.log("metaOgImage: ", metaOgImage);
              if (!metaOgImage) {
                metaOgImage = doc.createElement("meta");
                metaOgImage.setAttribute("property", "og:image");
                doc.head.appendChild(metaOgImage);
              }
              metaOgImage.setAttribute("content", seoData.ogImage);

              let metaTwitterImage = doc.querySelector(
                'meta[name="twitter:image"]'
              );
              console.log("metaTwitterImage: ", metaTwitterImage);
              if (!metaTwitterImage) {
                metaTwitterImage = doc.createElement("meta");
                metaTwitterImage.setAttribute("name", "twitter:image");
                doc.head.appendChild(metaTwitterImage);
              }
              metaTwitterImage.setAttribute("content", seoData.ogImage);
            }

            // SEO twitterCard
            if (seoData.twitterCard) {
              let metaTwitterCard = doc.querySelector(
                'meta[name="twitter:card"]'
              );
              if (!metaTwitterCard) {
                metaTwitterCard = doc.createElement("meta");
                metaTwitterCard.setAttribute("name", "twitter:card");
                doc.head.appendChild(metaTwitterCard);
              }
              metaTwitterCard.setAttribute("content", seoData.twitterCard);
            }

            if (seoData.schema_org) {
              let metaSchemaOrg = doc.querySelector('script[type="application/ld+json"]');
              if (!metaSchemaOrg) {
                metaSchemaOrg = doc.createElement("script");
                metaSchemaOrg.setAttribute("type", "application/ld+json");
                doc.head.appendChild(metaSchemaOrg);
              }
              metaSchemaOrg.textContent = seoData?.schema_org;
            }

            // Remove old custom code scripts (marked with data-ts-custom attribute)
            doc.head.querySelectorAll('script[data-ts-custom]').forEach((s) => s.remove());

            // Helper to inject JS — handles raw JS, single <script>, or multiple <script> tags
            const injectCustomScript = (rawJs, customType) => {
              if (!rawJs?.trim()) return;
              const trimmedJs = rawJs.trim();
              if (/<script/i.test(trimmedJs)) {
                const tempDoc = new DOMParser().parseFromString(
                  `<html><head>${trimmedJs}</head></html>`,
                  "text/html"
                );
                tempDoc.querySelectorAll("script").forEach((s) => {
                  const content = s.textContent.trim();
                  const newScript = doc.createElement("script");
                  newScript.setAttribute('data-ts-custom', customType);
                  Array.from(s.attributes).forEach((attr) =>
                    newScript.setAttribute(attr.name, attr.value)
                  );
                  if (content) newScript.textContent = s.textContent;
                  doc.head.appendChild(newScript);
                });
              } else {
                const customScript = doc.createElement("script");
                customScript.setAttribute('data-ts-custom', customType);
                customScript.textContent = trimmedJs;
                doc.head.appendChild(customScript);
              }
            };

            // 1. Inject global JS (applies to all pages)
            injectCustomScript(saveDataJson.saveData.templateData.globalCustomCode?.head_js, 'global');

            // 2. Inject page-specific JS
            injectCustomScript(pageData?.customCode?.head_js, 'page');
          }

          const themeCustomization = saveDataJson.saveData.themeCustomization;
          console.log(
            "Applying theme customization to ",
            fileName,
            themeCustomization
          );

          // if (themeCustomization && (themeCustomization.customVariables || themeCustomization.customFontVariables)) {
          //   let styleTag = doc.querySelector('style[data-theme-custom]');
          //   if (!styleTag) {
          //     styleTag = doc.createElement('style');
          //     styleTag.setAttribute('data-theme-custom', 'true');
          //     doc.head.appendChild(styleTag);
          //   }

          //   let cssContent = ':root {\n';
          //   if (themeCustomization.customVariables) {
          //     Object.entries(themeCustomization.customVariables).forEach(([property, value]) => {
          //       cssContent += `  ${property}: ${value};\n`;
          //     });
          //   }
          //   if (themeCustomization.customFontVariables) {
          //     Object.entries(themeCustomization.customFontVariables).forEach(([property, value]) => {
          //       cssContent += `  ${property}: ${value};\n`;
          //     });
          //   }
          //   cssContent += '}';
          //   styleTag.textContent = cssContent;
          // }

          const finalHtml = "<!DOCTYPE html>\n" + doc.documentElement.outerHTML;
          htmlObject[fileName] = finalHtml;

          console.log("FinalHtml After Data Changes: ", finalHtml);
          console.log(`✓ Successfully processed ${fileName}`);
        } catch (error) {
          console.error(`Failed to process ${fileName}:`, error);
        }
      }

      console.log("\n=== Processing Complete ===");
      console.log("All pages processed:", Object.keys(htmlObject));
      console.log("HTML processed", htmlObject);

      return {
        pages: htmlObject,
        themeCustomization: {
          customVariables:
            saveDataJson.saveData.themeCustomization.customVariables,
          customFontVariables:
            saveDataJson.saveData.themeCustomization.customFontVariables,
        },
        templateId: templateId,
      };
    } catch (error) {
      console.error("Error preparing HTML data:", error);
      return null;
    }
  };

  // Comprehensive GrapesJS cleanup function
  const cleanGrapesJSHTML = (doc, fileName) => {
    // Remove all GrapesJS-specific attributes
    const allElements = doc.querySelectorAll("*");
    allElements.forEach((element) => {
      // Remove GrapesJS data attributes
      const attributesToRemove = [];
      for (let attr of element.attributes) {
        if (
          attr.name.startsWith("data-gjs") ||
          attr.name === "data-highlightable" ||
          attr.name === "contenteditable"
        ) {
          attributesToRemove.push(attr.name);
        }
      }
      attributesToRemove.forEach((attr) => element.removeAttribute(attr));
    });

    // Remove GrapesJS wrapper elements and unwrap content
    const wrappers = doc.querySelectorAll('[data-gjs-type="wrapper"]');
    wrappers.forEach((wrapper) => {
      // Move all children out of wrapper
      while (wrapper.firstChild) {
        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
      }
      // Remove the empty wrapper
      wrapper.remove();
    });

    // Remove GrapesJS style containers and CSS rules
    const grapesStyleContainers = doc.querySelectorAll(
      ".gjs-css-rules, .gjs-js-cont"
    );
    grapesStyleContainers.forEach((container) => container.remove());

    // Remove GrapesJS generated style tags with editor styles
    const styleTags = doc.querySelectorAll("style");
    styleTags.forEach((styleTag) => {
      const styleContent = styleTag.textContent || styleTag.innerHTML;
      // Remove styles that contain GrapesJS-specific classes
      if (
        styleContent.includes("gjs-") ||
        styleContent.includes("data-gjs") ||
        styleContent.includes('[data-gjs-type="wrapper"]') ||
        styleContent.includes("body{margin-top:0px;margin-right:0px")
      ) {
        styleTag.remove();
      }
    });

    // Clean up the head section
    const head = doc.querySelector("head");
    if (head) {
      // Process stylesheet links with cache-busting (your existing logic)
      const styleLinks = head.querySelectorAll('link[rel="stylesheet"][href]');
      styleLinks.forEach((link) => {
        const href = link.getAttribute("href");
        const hrefFileName = href.split("/").pop().split("?")[0];
        if (hrefFileName.startsWith("custom-style.css")) {
          const randomKey =
            Date.now().toString() + Math.floor(Math.random() * 100000);
          const newHref = `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/custom-style.css?turbonckey=${randomKey}`;
          link.setAttribute("href", newHref);
        }
      });

      // Remove any leftover GrapesJS meta tags or head elements with data-gjs attributes
      const headElements = head.querySelectorAll(
        "*[data-gjs-type], *[data-gjs-highlightable]"
      );
      headElements.forEach((element) => {
        // Remove the attributes but keep the element if it's useful (like meta, title, etc.)
        element.removeAttribute("data-gjs-type");
        element.removeAttribute("data-gjs-highlightable");
        element.removeAttribute("id"); // Remove auto-generated IDs
      });
    }

    // Get the body content and clean it up
    const body = doc.querySelector("body");
    if (body) {
      // Remove inline styles that were added by GrapesJS
      if (body.hasAttribute("style")) {
        const style = body.getAttribute("style");
        // Remove GrapesJS specific styles but keep custom ones
        if (style === "" || style.includes("margin: 0; padding: 0;")) {
          body.removeAttribute("style");
        }
      }
    }

    // Process image sources to ensure they have full URLs (your existing logic)
    const images = doc.querySelectorAll("img[src]");
    images.forEach((img) => {
      const src = img.getAttribute("src");
      if (
        src &&
        !src.startsWith("http") &&
        !src.startsWith("//") &&
        !src.startsWith("/")
      ) {
        const cleanSrc = src.replace(/^\.\//, "");
        const newSrc = `${templateData.templateBaseUrl}${cleanSrc}`;
        img.setAttribute("src", newSrc);
      }
    });

    // Create clean HTML structure
    let cleanHtml;

    // Check if we have a proper HTML document structure
    if (
      doc.documentElement &&
      doc.documentElement.tagName.toLowerCase() === "html"
    ) {
      cleanHtml = "<!DOCTYPE html>\n" + doc.documentElement.outerHTML;
    } else {
      // If no proper HTML structure, wrap the body content
      const bodyContent = body ? body.innerHTML : doc.body?.innerHTML || "";
      cleanHtml = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${fileName.replace(".html", "")}</title>
</head>
<body>
    ${bodyContent}
</body>
</html>`;
    }

    // Final cleanup - remove extra whitespace and format
    return cleanHtml
      .replace(/\n\s*\n/g, "\n") // Remove empty lines
      .replace(/\s+/g, " ") // Normalize whitespace
      .replace(/>\s+</g, "><") // Remove whitespace between tags
      .trim();
  };

  useEffect(() => {
    let isNavigating = false;

    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
        return e.returnValue;
      }
    };

    const handlePopState = (e) => {
      if (isNavigating) return;

      e.preventDefault();
      isNavigating = true;

      if (hasUnsavedChanges) {
        const confirmLeave = window.confirm(
          "You have unsaved changes. Are you sure you want to leave? All changes will be lost."
        );

        if (confirmLeave) {
          handleBackClick();
        } else {
          isNavigating = false;
          window.history.pushState(null, "", window.location.pathname);
        }
      } else {
        isNavigating = false;
        window.history.back();
      }
    };

    // Prevent back navigation
    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (
      existingTemplateJSON?.themeCustomization &&
      Object.keys(originalTheme).length > 0
    ) {
      const savedTheme =
        existingTemplateJSON?.themeCustomization?.customVariables;
      const savedFonts =
        existingTemplateJSON?.themeCustomization?.customFontVariables;

      console.log("Original Theme:", originalTheme);

      if (savedTheme && Object.keys(savedTheme).length > 0) {
        setEditableTheme(savedTheme);
        console.log("Loaded saved theme:", savedTheme);
      } else if (Object.keys(editableTheme).length === 0) {
        setEditableTheme(originalTheme);
      }

      if (savedFonts && Object.keys(savedFonts).length > 0) {
        setEditableFonts(savedFonts);
        console.log("Loaded saved fonts:", savedFonts);
      } else if (Object.keys(editableFonts).length === 0) {
        setEditableFonts(originalFonts);
      }

      // Set selected theme names if saved
      if (existingTemplateJSON?.themeCustomization?.selectedColorTheme) {
        setSelectedColorTheme(
          existingTemplateJSON?.themeCustomization?.selectedColorTheme
        );
      }
      if (existingTemplateJSON?.themeCustomization?.selectedFontTheme) {
        setSelectedFontTheme(
          existingTemplateJSON?.themeCustomization?.selectedFontTheme
        );
      }
    }
  }, [existingTemplateJSON, originalTheme, originalFonts]);

  useEffect(() => {
    const fetchPublicApikey = async () => {
      try {
        const rcJson = await callApi(
          `/sites/${siteId}/pubapikey`,
          "GET",
          {},
          {}
        );
        console.log(rcJson.respBody);
        setPublicSiteId(rcJson.respBody.publicSiteId);
        setPublicKey(rcJson.respBody.publicKey);
      } catch (error) {
        console.error("Error fetching publicSiteId and publicKey", error);
      }
    };
    fetchPublicApikey();
  }, [siteId]);

  const handlePageChange = (e) => {
    const newPageIndex = parseInt(e.target.value);
    if (newPageIndex === selectedPageIndex) return;

    if (editorRef.current) {
      try {
        const currentPage =
          templateData.templateFiles.templatePageURLs[selectedPageIndex];
        const canvasDoc = editorRef.current.Canvas.getDocument();

        if (canvasDoc) {
          const completeHTML = canvasDoc.documentElement.outerHTML;
          setModifiedPageContents((prev) => ({
            ...prev,
            [currentPage]: completeHTML,
          }));
          const sharedElements = canvasDoc.querySelectorAll("[data-shared]");
          const updatedShared = {};

          sharedElements.forEach((el) => {
            const sharedId = el.getAttribute("data-shared");
            if (sharedId) {
              updatedShared[sharedId] = el.outerHTML;
            }
          });

          if (Object.keys(updatedShared).length > 0) {
            setSharedComponentChanges((prev) => ({
              ...prev,
              ...updatedShared,
            }));
          }
        }
      } catch (error) {
        console.error("Error capturing state before page change:", error);
      }
    }

    setSelectedPageIndex(newPageIndex);
    setDevice("Desktop");
    setAllChangedComponents(new Set());
  };

  const handleDeviceChange = (newDeviceName) => {
    if (!editorRef.current || isLoading || newDeviceName === device) return;

    try {
      const deviceManager = editorRef.current.DeviceManager;
      const targetDevice = deviceManager.get(newDeviceName);

      if (targetDevice) {
        deviceManager.select(targetDevice);
        setDevice(newDeviceName);
        setTimeout(() => {
          try {
            // console.log(
            //   `Device changed to: ${newDeviceName} and data restored`
            // );
          } catch (error) {
            // console.error("Error restoring data after device change:", error);
          }
        }, 100);
      } else {
        console.error(`Device '${newDeviceName}' not found in DeviceManager`);
      }
    } catch (error) {
      console.error("Error changing device:", error);
    }
  };

  async function handleAiChat(innerText) {
    try {
      setMessageLoader(true);
      console.log("Ai Function is triggered onSend: ", innerText);

      const pathParts = templateData?.templateFiles?.templatePageURLs?.[selectedPageIndex]?.split("/");
      const fileName = pathParts?.[pathParts?.length - 1]; // e.g., "index.html"
      const pageName = fileName?.replace(".html", ""); // e.g., "index"

      const UserRequestBody = {
        role: "user",
        content: innerText,
      };

      const new_message = {
        props: {
          model: {
            message: innerText,
            sender: "TurboSteed Ai",
            direction: "outgoing",
            position: "single",
          },
          children: (
            <Avatar
              src={
                "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
              }
              name="Eliot"
            />
          ),
        },
      };

      // Add message to the state
      setMessage((old_message) => [...old_message, new_message]);

      // Add loading message bubble
      const loading_message = {
        isLoading: true,
      };
      setMessage((old_message) => [...old_message, loading_message]);

      // Add user message to history and Adding the current page
      AiRequestBodyRef.current?.messages.push(UserRequestBody);
      AiRequestBodyRef.current.page = pageName;

      const response = await fetch(
        `https://${process.env.REACT_APP_HOST_URL}/users/${acctSid}/ai-editor/generate`,
        {
          method: "POST",
          body: JSON.stringify(AiRequestBodyRef.current),
          credentials: "include",
          headers: {
            Authorization: "Basic " + btoa(acctSid + ":" + act_e),
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
        // throw { status: response.status, message: "Failed to generate AI response" };
      }

      const json = await response.json();
      console.log(json);

      // For API Request Body
      const newMessage = {
        role: "assistant",
        content: json?.message,
      };

      // For Ai Message History
      const ai_reply = {
        props: {
          model: {
            message: json?.message,
            sender: "Zoe",
            direction: "incoming",
            position: "single",
          },
          children: (
            <Avatar
              name="Joe"
              src={
                "https://cdn-icons-png.flaticon.com/512/4712/4712109.png"
              }
            />
          ),
        },
      };

      // Remove loading message and add AI reply
      setMessage((old_message) => [...old_message.filter(m => !m.isLoading), ai_reply]);

      // Add Ai message to history
      AiRequestBodyRef.current?.messages.push(newMessage);

      // Applying the AI edits to the canvas is isolated from the AI request itself:
      // a binding/save failure here is logged but must NOT surface as a chat error,
      // since the AI reply already succeeded.
      try {
      const iframeDoc = editorRef.current?.Canvas?.getDocument();

      const saveToEditedData = (id, data) => {
        // Read the persisted JSON fresh so we keep every page's saved SEO/data intact
        // (this is what the publish/processing step reads back). Only fall back to a
        // skeleton when nothing is persisted yet (e.g. right after a template switch),
        // which is what previously caused the null `saveData` crash.
        const stored = JSON.parse(localStorage.getItem("EditedDataJson") || "null");
        const root = stored?.saveData
          ? stored
          : {
              saveData:
                existingTemplateJSON.current && Object.keys(existingTemplateJSON.current).length
                  ? existingTemplateJSON.current
                  : { templateData: { pages: {} }, sharedComponents: {}, contactForm: {}, themeCustomization: {} },
              templateId,
            };

        if (!root.saveData.templateData) root.saveData.templateData = { pages: {} };
        if (!root.saveData.templateData.pages) root.saveData.templateData.pages = {};
        if (!root.saveData.templateData.pages[fileName]) {
          root.saveData.templateData.pages[fileName] = { TemplateId: "", EditedData: [], SEO: [] };
        }

        const arr = root.saveData.templateData.pages[fileName].EditedData;
        const idx = arr.findIndex((e) => e.id === id);
        if (idx !== -1) arr[idx] = data; else arr.push(data);

        localStorage.setItem("EditedDataJson", JSON.stringify(root));
        existingTemplateJSON.current = root.saveData;
        setAllChangedComponents((prev) => new Set([...prev, id]));
        setHasUnsavedChanges(true);
      };

      // Resolves dot-notation path into a nested value
      // e.g. "services.0.title" → fields.services[0].title
      const getValueByPath = (obj, path) => {
        if (!path || !obj) return null;
        let current = obj;
        for (const part of path.split(".")) {
          if (current === null || current === undefined) return null;
          current = /^\d+$/.test(part) ? current[parseInt(part, 10)] : current[part];
        }
        return current ?? null;
      };

      // DOM-first binding engine
      // Scans all data-ts-* elements, compares new vs old value, applies only changed values
      const applyBindings = (newFields, oldFields) => {
        const elements = iframeDoc?.querySelectorAll(`
          [data-ts-path], [data-ts-text], [data-ts-src], [data-ts-href],
          [data-ts-bg], [data-ts-html], [data-ts-class], [data-ts-rating],
          [data-ts-progress], [data-ts-count], [data-ts-if], [data-ts-attr]
        `);

        elements?.forEach((el) => {
          const id = el.id;
          const tag = el.tagName.toLowerCase();

          // data-ts-if — conditional visibility (future use)
          if (el.dataset.tsIf) {
            const isNegated = el.dataset.tsIf.startsWith("!");
            const path = isNegated ? el.dataset.tsIf.slice(1) : el.dataset.tsIf;
            el.style.display = (isNegated ? !getValueByPath(newFields, path) : !!getValueByPath(newFields, path)) ? "" : "none";
          }

          // data-ts-path / data-ts-text — text, href, src based on tag
          const textPath = el.dataset.tsText || el.dataset.tsPath;
          if (textPath && !el.dataset.tsAttr && !el.dataset.tsSrc && !el.dataset.tsBg) {
            const newVal = getValueByPath(newFields, textPath);
            const oldVal = getValueByPath(oldFields, textPath);
            if (newVal !== null && newVal !== undefined && newVal !== oldVal) {
              if (tag === "img") {
                el.setAttribute("src", newVal);
                saveToEditedData(id, { id, tag, imageUrl: newVal, imageAltText: el.getAttribute("alt") || "" });
              } else if (tag === "a" && !el.dataset.tsText) {
                el.setAttribute("href", newVal);
                saveToEditedData(id, { id, tag, linkDetails: newVal });
              } else if (tag === "input" || tag === "textarea") {
                el.value = newVal;
                saveToEditedData(id, { id, tag, content: String(newVal) });
              } else {
                el.innerHTML = String(newVal);
                saveToEditedData(id, { id, tag, content: String(newVal) });
              }
            }
          }

          // data-ts-href — link href
          if (el.dataset.tsHref) {
            const newVal = getValueByPath(newFields, el.dataset.tsHref);
            const oldVal = getValueByPath(oldFields, el.dataset.tsHref);
            if (newVal && newVal !== oldVal) {
              el.setAttribute("href", newVal);
              saveToEditedData(id, { id, tag: "a", linkDetails: newVal });
            }
          }

          // data-ts-src — image/media src
          if (el.dataset.tsSrc) {
            const path = el.dataset.tsSrc; // save path before GrapesJS can overwrite it
            const newVal = getValueByPath(newFields, path);
            const oldVal = getValueByPath(oldFields, path);
            console.log(`[img] id="${id}" path="${path}" newVal=${newVal} oldVal=${oldVal}`);
            if (newVal && newVal !== oldVal) {
              console.log(`[img] BEFORE setAttribute — src="${el.getAttribute("src")}" data-ts-src="${el.getAttribute("data-ts-src")}"`);
              el.setAttribute("src", newVal);
              console.log(`[img] AFTER src set — src="${el.getAttribute("src")}" data-ts-src="${el.getAttribute("data-ts-src")}"`);
              el.setAttribute("data-ts-src", path); // restore path after src is set
              console.log(`[img] AFTER path restore — src="${el.getAttribute("src")}" data-ts-src="${el.getAttribute("data-ts-src")}"`);
              const alt = el.dataset.tsAlt ? getValueByPath(newFields, el.dataset.tsAlt) : el.getAttribute("alt") || "";
              saveToEditedData(id, { id, tag: "img", imageUrl: newVal, imageAltText: alt || "" });
            } else {
              console.log(`[img] SKIPPED — condition failed (newVal=${newVal}, same=${newVal === oldVal})`);
            }
          }

          // data-ts-alt — image alt (applied alongside data-ts-src)
          if (el.dataset.tsAlt) {
            const newVal = getValueByPath(newFields, el.dataset.tsAlt);
            const oldVal = getValueByPath(oldFields, el.dataset.tsAlt);
            if (newVal && newVal !== oldVal) el.setAttribute("alt", newVal);
          }

          // data-ts-bg — CSS background image
          if (el.dataset.tsBg) {
            const newVal = getValueByPath(newFields, el.dataset.tsBg);
            const oldVal = getValueByPath(oldFields, el.dataset.tsBg);
            if (newVal && newVal !== oldVal) {
              el.style.backgroundImage = `url('${newVal}')`;
              saveToEditedData(id, { id, tag, content: newVal });
            }
          }

          // data-ts-class — CSS class replacement (supports bi-* Bootstrap icons)
          if (el.dataset.tsClass) {
            const newVal = getValueByPath(newFields, el.dataset.tsClass);
            const oldVal = getValueByPath(oldFields, el.dataset.tsClass);
            if (newVal && newVal !== oldVal) {
              const pattern = el.dataset.tsClassPattern;
              if (pattern) {
                el.className = el.className.replace(new RegExp(pattern.replace("*", "\\S*"), "g"), "").trim() + " " + newVal;
              } else if (el.classList.contains("bi")) {
                const current = Array.from(el.classList).find((c) => c.startsWith("bi-"));
                if (current) el.classList.remove(current);
                el.classList.add(newVal);
              } else {
                el.classList.add(newVal);
              }
              saveToEditedData(id, { id, tag, content: newVal });
            }
          }

          // data-ts-rating — star rating HTML (future use)
          if (el.dataset.tsRating) {
            const newVal = getValueByPath(newFields, el.dataset.tsRating);
            const oldVal = getValueByPath(oldFields, el.dataset.tsRating);
            if (newVal !== null && newVal !== undefined && newVal !== oldVal) {
              let html = "";
              for (let i = 1; i <= 5; i++) {
                if (i <= newVal) html += `<i class="bi bi-star-fill"></i>`;
                else if (i - 0.5 <= newVal) html += `<i class="bi bi-star-half"></i>`;
                else html += `<i class="bi bi-star"></i>`;
              }
              el.innerHTML = html;
              saveToEditedData(id, { id, tag, content: html });
            }
          }

          // data-ts-progress — progress bar width (future use)
          if (el.dataset.tsProgress) {
            const newVal = getValueByPath(newFields, el.dataset.tsProgress);
            const oldVal = getValueByPath(oldFields, el.dataset.tsProgress);
            if (newVal !== null && newVal !== undefined && newVal !== oldVal) {
              el.style.width = `${newVal}%`;
              el.setAttribute("aria-valuenow", newVal);
              saveToEditedData(id, { id, tag, content: String(newVal) });
            }
          }

          // data-ts-count — number counter with K/M formatting (future use)
          if (el.dataset.tsCount) {
            const newVal = getValueByPath(newFields, el.dataset.tsCount);
            const oldVal = getValueByPath(oldFields, el.dataset.tsCount);
            if (newVal !== null && newVal !== undefined && newVal !== oldVal) {
              const formatted = newVal >= 1000000 ? (newVal / 1000000).toFixed(1) + "M"
                : newVal >= 1000 ? (newVal / 1000).toFixed(1) + "K"
                : newVal.toLocaleString();
              el.textContent = formatted;
              saveToEditedData(id, { id, tag, content: formatted });
            }
          }

          // data-ts-attr — set any arbitrary HTML attribute (future use)
          if (el.dataset.tsAttr && el.dataset.tsPath) {
            const newVal = getValueByPath(newFields, el.dataset.tsPath);
            const oldVal = getValueByPath(oldFields, el.dataset.tsPath);
            if (newVal !== null && newVal !== undefined && newVal !== oldVal) {
              el.setAttribute(el.dataset.tsAttr, newVal);
              saveToEditedData(id, { id, tag, content: String(newVal) });
            }
          }
        });
      };

      // SEO handled separately
      const seoVal = json?.fields?.seo;
      if (seoVal) {
        const seoFields = {};
        Object.entries(seoVal).forEach(([k, v]) => {
          if (!v) return;
          if (k === "keywords" && Array.isArray(v)) seoFields[k] = v.join(", ");
          else if (k === "schema_org" && typeof v === "object") seoFields[k] = JSON.stringify(v);
          else seoFields[k] = v;
        });
        setSeoData((prev) => { const updated = { ...prev, ...seoFields }; updateSeoForCurrentPage(updated); return updated; });
      }

      applyBindings(json?.fields || {}, AiRequestBodyRef.current?.fields || {});
      } catch (applyError) {
        console.error("AI edit apply error: ", applyError);
      } finally {
        AiRequestBodyRef.current.complete = json?.complete;
        AiRequestBodyRef.current.fields = json?.fields;
        AiRequestBodyRef.current.isAuthenticated = json?.isAuthenticated;
        captureCurrentPageState();
      }

    } catch (error) {
      console.log("AI Chat error: ", error)
      console.log("Error Status: ", error.status);
      console.log("Error Message: ", error.message)

      if (error) {
        const ai_reply = {
          props: {
            model: {
              message: "Something went wrong. Please try again later",
              sender: "Zoe",
              direction: "incoming",
              position: "single",
            },
            children: (
              <Avatar
                name="Joe"
                src={
                  "https://cdn-icons-png.flaticon.com/512/4712/4712109.png"
                }
              />
            ),
          },
        };

        // Remove loading message and add error reply
        setMessage((old_message) => [...old_message.filter(m => !m.isLoading), ai_reply]);
      }
    } finally {
      setMessageLoader(false)
    }
  }

  async function handleFileUpload(event) {
    try {
      const file = event.target.files[0];
      if (!file) return;

      console.log("AiChat FileUpload: ", file)
      const maxSizeInMB = 5;
      if (file.size > maxSizeInMB * 1024 * 1024) {
        alert(`File size must be less than ${maxSizeInMB}MB`);
        return;
      }

      // Show uploading message bubble
      const uploading_message = {
        isUploading: true,
      };
      setMessage((old_message) => [...old_message, uploading_message]);

      const imagePath = await saveImageToTemplateFolder(file);
      console.log("File Uploaded: ", imagePath);

      // Remove uploading message
      setMessage((old_message) => old_message.filter(m => !m.isUploading));

      if (!imagePath) {
        const ai_reply = {
          props: {
            model: {
              message: "Sorry, something went wrong. Please try again later.",
              sender: "Zoe",
              direction: "incoming",
              position: "single",
            },
            children: (
              <Avatar
                name="Joe"
                src={
                  "https://cdn-icons-png.flaticon.com/512/4712/4712109.png"
                }
              />
            ),
          },
        };

        // Add message to the state
        setMessage((old_message) => [...old_message, ai_reply]);
      } else {

        await handleAiChat(imagePath);
        // const ai_reply = {
        //   props: {
        //     model: {
        //       message: "File uploaded successfully",
        //       sender: "Zoe",
        //       direction: "incoming",
        //       position: "single",
        //     },
        //     children: (
        //       <Avatar
        //         name="Joe"
        //         src={
        //           "https://cdn-icons-png.flaticon.com/512/4712/4712109.png"
        //         }
        //       />
        //     ),
        //   },
        // };

        // // Add message to the state
        // setMessage((old_message) => [...old_message, ai_reply]);
      }

    } catch (error) {
      console.log("File Upload Error: ", error);
      console.log("Error Status: ", error.status);
      console.log("Error Message: ", error.message)

      // Remove uploading message on error
      setMessage((old_message) => old_message.filter(m => !m.isUploading));

      if (error.message === `Upload failed: 429 - {"message":"Asset size quota exceeded, uploads paused"}`) {

        // For Ai Message History
        const ai_reply = {
          props: {
            model: {
              message: "Your plan’s asset storage limit has been reached. Please upgrade your plan or remove some assets to continue",
              sender: "Zoe",
              direction: "incoming",
              position: "single",
            },
            children: (
              <Avatar
                name="Joe"
                src={
                  "https://cdn-icons-png.flaticon.com/512/4712/4712109.png"
                }
              />
            ),
          },
        };

        // Add message to the state
        setMessage((old_message) => [...old_message, ai_reply]);
      } else {
        // Generic error message
        const ai_reply = {
          props: {
            model: {
              message: "Failed to upload image. Please try again.",
              sender: "Zoe",
              direction: "incoming",
              position: "single",
            },
            children: (
              <Avatar
                name="Joe"
                src={
                  "https://cdn-icons-png.flaticon.com/512/4712/4712109.png"
                }
              />
            ),
          },
        };

        setMessage((old_message) => [...old_message, ai_reply]);
      }

    } finally {
      setMessageLoader(false)
    }
  }

  const handleSave = async () => {
    if (!editorRef.current || !templateData || isLoading) {
      alert("Editor not ready or loading. Please try again.");
      return;
    }

    try {
      setIsLoading(true);

      // Capture current page state
      if (editorRef.current) {
        const currentPagePath =
          templateData.templateFiles.templatePageURLs[selectedPageIndex];
        const canvasDoc = editorRef.current.Canvas.getDocument();
        if (canvasDoc) {
          const completeHTML = canvasDoc.documentElement.outerHTML;

          console.log("HandleSave HTML: ", completeHTML);

          setModifiedPageContents((prev) => ({
            ...prev,
            [currentPagePath]: completeHTML,
          }));
          const sharedElements = canvasDoc.querySelectorAll("[data-shared]");
          const capturedShared = { ...sharedComponentChanges };

          sharedElements.forEach((el) => {
            const sharedId = el.getAttribute("data-shared");
            if (sharedId) {
              capturedShared[sharedId] = el.outerHTML;
            }
          });
          setSharedComponentChanges(capturedShared);

          window.currentSharedComponents = capturedShared;
        }
      }

      console.log(
        "ExistingTemplateJSON DATA in handleSave: ",
        existingTemplateJSON.current
      );

      let sitesResponse = {};
      if (Object.keys(siteData).length !== 0) {
        sitesResponse = siteData;
      } else {
        sitesResponse = await callApi("/sites/" + siteId, "GET", {}, {});
        setSiteData(sitesResponse);
      }
      const customDomain = sitesResponse?.respBody?.customDomain || ""; // Custom Domain
      // const customDomain = 'xyz.com'; // Placeholder for testing

      const saveData = {
        templateData: {
          pages: existingTemplateJSON.current?.templateData?.pages || {},
        },
        sharedComponents: existingTemplateJSON.current?.sharedComponents || {},
        contactForm: existingTemplateJSON.current?.contactForm || {},
        themeCustomization: existingTemplateJSON.current?.themeCustomization || {},
      };

      // if (Object.keys(saveData.themeCustomization).length === 0) alert("Theme root variables don't exist");

      console.log(
        "SEOData handleSave: ",
        seoData
      );

      const existingThemeCustomization =
        existingTemplateJSON.current?.themeCustomization || {};
      const currentSavedTheme =
        existingTemplateJSON.current?.themeCustomization?.customVariables || {};
      const currentSavedFonts =
        existingTemplateJSON.current?.themeCustomization?.customFontVariables || {};

      // if (Object.keys(saveData.themeCustomization.customVariables).length === 0) alert("CustomVariables variables don't exist");

      console.log("Current Saved Theme: ", currentSavedTheme);
      console.log("Cuurent Saved Font: ", currentSavedFonts);

      const themeHasChanges = (() => {
        const compareAgainst =
          Object.keys(currentSavedTheme).length > 0
            ? currentSavedTheme
            : originalTheme;
        return Object.keys(editableTheme).some((property) => {
          return editableTheme[property] !== compareAgainst[property];
        });
      })();

      const fontsHaveChanges = (() => {
        const compareAgainst =
          Object.keys(currentSavedFonts).length > 0
            ? currentSavedFonts
            : originalFonts;
        return Object.keys(editableFonts).some((property) => {
          return editableFonts[property] !== compareAgainst[property];
        });
      })();

      console.log("Themehas changes: ", themeHasChanges);
      console.log("FontsHaveChanges: ", fontsHaveChanges);

      saveData.themeCustomization = {
        // ...existingThemeCustomization,
        customVariables: themeHasChanges
          ? editableTheme
          : Object.keys(currentSavedTheme).length > 0
            ? currentSavedTheme
            : originalTheme,
        customFontVariables: fontsHaveChanges
          ? editableFonts
          : Object.keys(currentSavedFonts).length > 0
            ? currentSavedFonts
            : originalFonts,
        originalThemeVariables: originalTheme,
        originalFontVariables: originalFonts,
        ...(themeHasChanges && {
          colorThemeLastModified: new Date().toISOString(),
        }),
        ...(fontsHaveChanges && {
          fontThemeLastModified: new Date().toISOString(),
        }),
        selectedColorTheme:
          selectedColorTheme || existingThemeCustomization.selectedColorTheme,
        selectedFontTheme:
          selectedFontTheme || existingThemeCustomization.selectedFontTheme,
        lastModified: new Date().toISOString(),
      };

      console.log("Save Data Before Processing: ", saveData);

      const isSharedComponent = (element) => {
        if (element.getAttribute("data-shared")) return true;
        const navbar = element.closest(
          'nav, .navbar, [data-component="navbar"]'
        );
        const footer = element.closest(
          'footer, .footer, [data-component="footer"]'
        );
        return !!(navbar || footer);
      };

      const getSharedComponentType = (element) => {
        if (element.closest('nav, .navbar, [data-component="navbar"]'))
          return "navbar";
        if (element.closest('footer, .footer, [data-component="footer"]'))
          return "footer";
        return null;
      };

      const sharedComponentEdits = {
        navbar: [],
        footer: [],
        favicon: [],
      };

      // FIX: Load ALL pages before processing
      console.log("Loading all pages before save...");
      const allPagesLoaded = {};

      for (
        let pageIndex = 0;
        pageIndex < templateData.templateFiles.templatePageURLs.length;
        pageIndex++
      ) {
        const pagePath = templateData.templateFiles.templatePageURLs[pageIndex];
        const pageName = pagePath.split("/").pop();

        let pageHtml;

        // Current page from editor
        if (pageIndex === selectedPageIndex && editorRef.current) {
          const canvasDoc = editorRef.current.Canvas.getDocument();
          pageHtml = canvasDoc ? canvasDoc.documentElement.outerHTML : null;
          console.log("Current Page Editor: ", pageHtml);
        }
        // Modified pages
        else if (modifiedPageContents[pagePath]) {
          pageHtml = modifiedPageContents[pagePath];

          console.log("Modified Page Editor: ", pageHtml);
        }
        // Original pages
        else if (originalPageContents[pagePath]) {
          pageHtml = originalPageContents[pagePath];
        }
        // Load from URL if not in memory
        else {
          console.log(`Loading ${pageName} from URL...`);
          try {
            pageHtml = await loadPageContent(pagePath);

            if (pageHtml) {
              // Store in originalPageContents for future use
              setOriginalPageContents((prev) => ({
                ...prev,
                [pagePath]: pageHtml,
              }));
            }
          } catch (error) {
            console.error(`Failed to load ${pageName}:`, error);
            continue;
          }
        }

        if (pageHtml) {
          allPagesLoaded[pageName] = pageHtml;
          console.log(`✓ Loaded ${pageName}`);
        } else {
          console.warn(`✗ Could not load ${pageName}`);
        }
      }

      console.log(`Total pages loaded: ${Object.keys(allPagesLoaded).length}`);

      // Process all loaded pages to extract changes
      for (
        let pageIndex = 0;
        pageIndex < templateData.templateFiles.templatePageURLs.length;
        pageIndex++
      ) {
        const pagePath = templateData.templateFiles.templatePageURLs[pageIndex];
        const pageName = pagePath.split("/").pop();
        console.log(`Processing changes for ${pageName}...`);

        const pageHtml = allPagesLoaded[pageName];

        if (!pageHtml) {
          console.warn(`Skipping ${pageName} - no HTML available`);
          continue;
        }

        const tempDoc = new DOMParser().parseFromString(pageHtml, "text/html");
        const allElements = tempDoc.querySelectorAll("*[id]");

        // Initialize page data if it doesn't exist
        if (!saveData.templateData.pages[pageName]) {
          saveData.templateData.pages[pageName] = {
            TemplateId: templateId,
            EditedData: [],
            SEO: [],
          };
        }

        const pageData = saveData.templateData.pages[pageName];

        allElements.forEach((element) => {
          const elementId = element.id;
          if (!elementId) return;

          const originalData = originalComponentData[elementId];
          if (!originalData) return;

          const tagName = element.tagName.toLowerCase();
          const changes = {};

          if (tagName !== "img") {
            const currentContent =
              element.textContent?.trim() || element.innerText?.trim() || "";
            if (tagName === "a") {
              if (currentContent && currentContent !== originalData.content) {
                changes.content = currentContent;
              }
            } else {
              if (currentContent !== originalData.content) {
                changes.content = currentContent;
              }
            }
          }

          if (tagName === "img") {
            const currentSrc = element.getAttribute("src") || "";
            const currentAlt = element.getAttribute("alt") || "";
            if (currentSrc !== originalData.src) {
              changes.imageUrl = currentSrc;
              changes.imageAltText = currentAlt;
            }
            if (currentAlt !== originalData.alt) {
              changes.imageUrl = currentSrc;
              changes.imageAltText = currentAlt;
            }
          }

          if (tagName === "video") {
            console.log("Video Element Found: ", element);
            const currentSrc = element.getAttribute("src") || "";
            console.log("Current Src: ", currentSrc);
            if (currentSrc !== originalData.src) {
              changes.videoSrc = currentSrc;
            }
          }

          const currentHref = element.getAttribute("href") || "";
          if (currentHref !== originalData.href) {
            changes.linkDetails = currentHref;
          }

          if (Object.keys(changes).length > 0) {
            const editData = {
              id: elementId,
              tag: tagName,
              ...changes,
            };

            if (isSharedComponent(element)) {
              const sharedType = getSharedComponentType(element);
              if (
                sharedType &&
                !sharedComponentEdits[sharedType].find(
                  (edit) => edit.id === elementId
                )
              ) {
                sharedComponentEdits[sharedType].push(editData);
              }
            } else {
              const existingEditIndex = pageData.EditedData.findIndex(
                (edit) => edit.id === elementId
              );
              if (existingEditIndex >= 0) {
                pageData.EditedData[existingEditIndex] = {
                  ...pageData.EditedData[existingEditIndex],
                  ...changes,
                };
              } else {
                pageData.EditedData.push(editData);
              }
            }
          }
        });

        // Handle SEO data
        const pageSeoData = seoPerPage[pagePath] || {};
        const originalSeo = originalSeoData[pagePath] || {
          meta_title: "",
          meta_description: "",
          keywords: "",
          canonicalUrl: "",
          robots: "",
          ogType: "",
          ogUrl: "",
          og_title: "",
          og_description: "",
          ogImage: "",
          twitterCard: "",
          twitterDescription: "",
          twitterTitle: "",
          twitterImage: "",
          schema_org: ""
        };

        const seoHasChanges =
          pageSeoData.meta_title !== originalSeo.meta_title ||
          pageSeoData.meta_description !== originalSeo.meta_description ||
          pageSeoData.canonicalUrl !== originalSeo.canonicalUrl ||
          pageSeoData.keywords !== originalSeo.keywords ||
          pageSeoData.robots !== originalSeo.robots ||
          pageSeoData.ogType !== originalSeo.ogType ||
          pageSeoData.ogUrl !== originalSeo.ogUrl ||
          pageSeoData.og_title !== originalSeo.og_title ||
          pageSeoData.og_description !== originalSeo.og_description ||
          pageSeoData.ogImage !== originalSeo.ogImage ||
          pageSeoData.twitterCard !== originalSeo.twitterCard ||
          pageSeoData.twitterDescription !== originalSeo.twitterDescription ||
          pageSeoData.twitterTitle !== originalSeo.twitterTitle ||
          pageSeoData.twitterImage !== originalSeo.twitterImage ||
          pageSeoData.schema_org !== originalSeo.schema_org;

        console.log("SEO Has Changes: ", pageSeoData);

        if (seoHasChanges) {
          console.log("seoHasChanges True")
          console.log("All Seo Properties: ", pageSeoData.meta_title);
          pageData.SEO = [
            {
              meta_title: pageSeoData.meta_title || "",
              meta_description: pageSeoData.meta_description || "",
              metaTags: pageSeoData.keywords || "",
              canonicalUrl:
                pageSeoData.canonicalUrl ||
                (customDomain !== ""
                  ? `https://www.${customDomain}/${pageName}`
                  : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/${pageName}`),
              robots: pageSeoData.robots || "",
              ogType: pageSeoData.ogType || "",
              ogUrl:
                pageSeoData.canonicalUrl ||
                (customDomain !== ""
                  ? `https://www.${customDomain}/${pageName}`
                  : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/${pageName}`),
              og_title: pageSeoData.og_title || "",
              og_description: pageSeoData.og_description || "",
              ogImage: pageSeoData.ogImage || "",
              twitterCard: pageSeoData.twitterCard || "",
              twitterDescription: pageSeoData.og_description || "",
              twitterTitle: pageSeoData.og_title || "",
              twitterImage: pageSeoData.ogImage || "",
              schema_org: pageSeoData.schema_org || ""
            },
          ];
        } else if (!pageData.SEO || pageData.SEO.length === 0) {
          console.log("SEOhaspage changes false")
          pageData.SEO =
            existingTemplateJSON.current?.templateData?.pages[pageName]?.SEO || [];
        }

        console.log("existingTemplateJSON current page SEO: ", existingTemplateJSON.current?.templateData?.pages[pageName]?.SEO);
        console.log("SEO pageData", pageData.SEO);

        // Handle custom code - always save per-page JS independently
        const pageCustomJs = customCodePerPage[pagePath]?.head_js;
        const existingCustomJs =
          existingTemplateJSON.current?.templateData?.pages[pageName]?.customCode?.head_js;
        pageData.customCode = {
          head_js: pageCustomJs !== undefined ? pageCustomJs : (existingCustomJs || '')
        };
      }

      // Save global custom code at template level (applies to all pages)
      const existingGlobalJs = existingTemplateJSON.current?.templateData?.globalCustomCode?.head_js;
      saveData.templateData.globalCustomCode = {
        head_js: customCodeGlobal.head_js || existingGlobalJs || ''
      };

      // Handle favicon and other shared components
      if (Object.keys(sharedComponentChanges).length > 0) {
        Object.entries(sharedComponentChanges).forEach(
          ([sharedId, sharedData]) => {
            if (sharedId === "favicon" && Array.isArray(sharedData)) {
              sharedComponentEdits.favicon = sharedData.map((item) => ({
                id: item.id,
                tag: item.tag || "link",
                rel: item.rel || "icon",
                imageUrl: item.imageUrl || item.href,
                href: item.imageUrl || item.href,
              }));
            }
          }
        );
      }

      Object.entries(sharedComponentEdits).forEach(([componentType, edits]) => {
        if (edits.length > 0) {
          saveData.sharedComponents[componentType] = edits;
        }
      });

      const apiUrl = process.env.REACT_APP_HOST_URL;
      if (publicKey && publicSiteId && apiUrl) {
        saveData.contactForm = {
          accountId: publicSiteId,
          accountApiToken: publicKey,
          apiUrl: apiUrl,
        };
      }

      const JsonRequestBody = {
        saveData,
        templateId: templateId,
      };

      localStorage.setItem("EditedDataJson", JSON.stringify(JsonRequestBody));
      localStorage.setItem(
        "sharedComponentsHTML",
        JSON.stringify(window.currentSharedComponents)
      );
      console.log("Saved data structure:", JsonRequestBody);
      console.log(
        "Pages in saved data:",
        Object.keys(JsonRequestBody.saveData.templateData.pages)
      );

      const editedHtmlData = await handleFetchHtmlData();
      if (!editedHtmlData) {
        throw new Error("Failed to fetch HTML data");
      }

      const lastModified = new Date().toISOString().substring(0, 10);
      console.log(customDomain === "" ? "Empty String" : "Not Empty String");

      let requestBody = {
        data: {
          editedDataJson: {
            templateData: saveData,
            templateId: templateId,
          },
          editedHtmlDataJson: editedHtmlData,
          AiChatHistory: AiRequestBodyRef.current.fields,
        },
      };

      // Check if customDomain exist then send the sitemap data
      if (customDomain !== "") {
        requestBody = {
          data: {
            sitemap: {
              url: [],
            },
            editedDataJson: {
              templateData: saveData,
              templateId: templateId,
            },
            editedHtmlDataJson: editedHtmlData,
            AiChatHistory: AiRequestBodyRef.current.fields,
          },
        };

        Object.keys(JsonRequestBody.saveData.templateData.pages).forEach(
          (pageName) => {
            console.log("Page Name for Sitemap: ", pageName);

            requestBody?.data?.sitemap?.url.push({
              loc: `https://www.${customDomain}/${pageName}`,
              lastmod: lastModified,
            });
          }
        );

        console.log("Request Body with Sitemap: ", requestBody);
      }

      const cleanJsonString = (obj) => {
        return JSON.stringify(obj)
          .replace(/\\n/g, " ")
          .replace(/\\/g, "")
          .replace(/\n/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      };

      const JsonDataFinal = cleanJsonString(requestBody);
      console.log("Save Data Structure:", JsonDataFinal);
      // console.log("EditedJsonData: ", JsonRequestBody)
      setTemplateJson(JSON.stringify(requestBody, null, 2));

      // Send the request
      const handleSaveUrl = `https://${process.env.REACT_APP_HOST_URL}/users/${acctSid}/sites/${siteId}/applyTemplate`;
      const response = await fetch(handleSaveUrl, {
        method: "POST",
        credentials: "include",
        headers: {
          Authorization: "Basic " + btoa(acctSid + ":" + act_e),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error("Failed to save template");
      }

      localStorage.setItem("templateJSON", JSON.stringify(requestBody));
      setAllChangedComponents(new Set());
      setHasUnsavedChanges(false);

      if (themeHasChanges) {
        setOriginalTheme(editableTheme);
      }

      if (fontsHaveChanges) {
        setOriginalFonts(editableFonts);
      }

      Object.keys(originalComponentData).forEach((compId) => {
        if (allChangedComponents.has(compId)) {
          const element =
            editorRef.current?.Canvas?.getDocument()?.getElementById(compId);
          if (element) {
            const tagName = element.tagName.toLowerCase();
            setOriginalComponentData((prev) => ({
              ...prev,
              [compId]: {
                content:
                  tagName !== "img" ? element.textContent?.trim() || "" : "",
                href: element.getAttribute("href") || "",
                alt: tagName === "img" ? element.getAttribute("alt") || "" : "",
                src: tagName === "img" ? element.getAttribute("src") || "" : "",
                title: element.getAttribute("title") || "",
                target: element.getAttribute("target") || "",
              },
            }));
          }
        }
      });

      if (response.ok) {
        setShowSuccessPopUp(true);
      }
    } catch (error) {
      console.error("Error saving template:", error);
      alert("Error saving template: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // const handlePreview = () => {
  //   if (editorRef.current && !isLoading && templateData) {
  //     try {
  //       const editor = editorRef.current;
  //       editor.store && editor.store();

  //       // Get the full rendered document from GrapesJS Canvas
  //       const canvasDoc = editor.Canvas.getDocument();
  //       if (!canvasDoc) {
  //         alert("Canvas is not ready. Please try again.");
  //         return;
  //       }

  //       // Get the FULL HTML (including navbar, background, etc.)
  //       const fullHtml = canvasDoc.documentElement.outerHTML;

  //       // SEO Meta Info
  //       const currentPage = templateData.templateFiles.templatePageURLs[selectedPageIndex];
  //       const meta = seoPerPage[currentPage] || {
  //         title: "",
  //         description: "",
  //         keywords: "",
  //       };
  //       const baseUrl = window.location.origin;

  //       // Get extracted assets for current page
  //       const pageAssets = extractedAssets[currentPage] || { styles: [], scripts: [] };

  //       // Inject meta tags, base URL, and external assets dynamically
  //       let headContent = `<head>
  //           <meta charset="UTF-8" />
  //           <meta name="viewport" content="width=device-width, initial-scale=1" />
  //           <base href="${baseUrl}/" />
  //           <title>${meta.title || "Untitled Page"}</title>
  //           ${meta.description
  //           ? `<meta name="description" content="${meta.description}" />`
  //           : ""
  //         }
  //           ${meta.keywords
  //           ? `<meta name="keywords" content="${meta.keywords}" />`
  //           : ""
  //         }`;
  //       const faviconLink = canvasDoc.querySelector('link[rel*="icon"]');
  //       if (faviconLink) {
  //         headContent += `\n          ${faviconLink.outerHTML}`;
  //       }
  //       pageAssets.styles.forEach(style => {
  //         headContent += `\n          <link rel="stylesheet" href="${templateData.templateBaseUrl}${style.href}" />`;
  //       });
  //       headContent += `
  //           <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />`;
  //       pageAssets.scripts.filter(script => !script.isInline).forEach(script => {
  //         headContent += `\n          <script src="${script.src}"></script>`;
  //       });
  //       headContent += `\n        `;
  //       const previewHtml = fullHtml.replace(
  //         /<head[^>]*>/i,
  //         headContent
  //       );
  //       let finalHtml = previewHtml;
  //       const inlineScripts = pageAssets.scripts.filter(script => script.isInline);
  //       if (inlineScripts.length > 0) {
  //         let scriptsHtml = '';
  //         inlineScripts.forEach(script => {
  //           scriptsHtml += `\n        <script>${script.content}</script>`;
  //         });
  //         finalHtml = previewHtml.replace(
  //           /<\/body>/i,
  //           `${scriptsHtml}\n      </body>`
  //         );
  //       }

  //       // Open in new window
  //       const previewWindow = window.open(
  //         `http://localhost:9000/${currentPage}`
  //       );
  //       if (previewWindow) {
  //         previewWindow.document.open();
  //         previewWindow.document.write(finalHtml);
  //         previewWindow.document.close();
  //       } else {
  //         alert("Popup blocked! Please allow popups to view preview.");
  //       }
  //     } catch (error) {
  //       alert("Error generating preview: " + error.message);
  //     }
  //   }
  // };

  // Undo Button Functionality

  async function UndoButton() {
    try {
      editorRef.current.UndoManager.undo();
      console.log("Undo performed successfully");
    } catch (error) {
      console.error("Error performing undo:", error);
    }
  }

  if (!templateData)
    return (
      <Container
        fluid
        className="min-vh-100 d-flex align-items-center justify-content-center dashboard-bg"
      >
        <div className="text-center">
          <Spinner
            animation="border"
            variant="primary"
            style={{ width: "2.5rem", height: "2.5rem" }}
          />
          <div className="mt-3 text-dashboard-secondary dashboard-text-base">
            Loading...
          </div>
        </div>
      </Container>
    );
  const handleBackClick = () => {
    navigate(`/${siteId}/editor`);
  };
  return (
    <div className="editor-wrapper">
      <div className="top-bar">
        <div className="left-controls">
          <div>
            <button
              className="back-btn"
              onClick={togglePopup}
            >
              <FiArrowLeft size={18} />
            </button>

            {showBackPopUp && (
              <div className="custom-modal-overlay">
                <div className="custom-modal">
                  <div
                    className="custom-modal-header row border-none m-0 p-0"
                    style={{ width: "fit-content" }}
                  >
                    <button
                      type="button border-none m-0 p-0"
                      className="close"
                      onClick={closePopup}
                    >
                      &times;
                    </button>
                  </div>
                  <div className="custom-modal-body">
                    <p className="text-black">
                      Are you sure you want to go back ? Leaving this will lead
                      to all the edited data loss
                    </p>
                  </div>
                  <div className="custom-modal-footer">
                    <button
                      className="btn btn-primary"
                      onClick={handleBackClick}
                    >
                      Exit the page
                    </button>
                    <button className="btn btn-secondary" onClick={closePopup}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <span className="topbar-divider"></span>

          <div className="d-flex">
            <select
              className="page-select rounded"
              value={selectedPageIndex}
              onChange={handlePageChange}
              disabled={isLoading}
            >
              {templateData.templateFiles.templatePageURLs.map((page, i) => (
                <option key={i} value={i}>
                  {page.split("/").pop().replace(".html", "") === "index"
                    ? "Home"
                    : page.split("/").pop().replace(".html", "")}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="center-info">
          <div className="devices rounded">
            {["Desktop", "Tablet", "Mobile"].map((dev) => (
              <button
                key={dev}
                onClick={() => handleDeviceChange(dev)}
                className={`device-btn ${device === dev ? "active" : ""}`}
                disabled={isLoading}
              >
                {(dev === "Desktop" && <FiMonitor size={20} />) ||
                  (dev === "Tablet" && <FaTabletAlt size={20} />) ||
                  (dev === "Mobile" && <FaMobileAlt size={20} />)}
              </button>
            ))}
          </div>
        </div>
        <div className="right-controls">
          <button
            onClick={handleSave}
            className="save-btn rounded"
            disabled={isLoading}
          >
            Save
          </button>
          <button
            className="undo-btn"
            onClick={UndoButton}
            disabled={isLoading}
          >
            Undo
          </button>
          {showSuccessPopUp && (
            <div className="custom-modal-overlay">
              <div className="custom-modal">
                <div className="custom-modal-body">
                  <p className="text-black">
                    Changes are being made to your website. Redirecting to
                    templates
                  </p>
                </div>
                <div className="custom-modal-footer">
                  <button className="btn btn-primary" onClick={handleBackClick}>
                    Exit the page
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* <button
            onClick={handlePreview}
            className="preview-btn"
            disabled={isLoading}
          >
            Preview
          </button> */}
        </div>
      </div>

      <div className="editor-content">
        <div className="properties-panel">
          <div className="panel-toggle">
            <button
              className={`toggle-btn ${activeTab === "properties" ? "active" : ""
                }`}
              onClick={() => setActiveTab("properties")}
            >
              <FiEdit3 size={15} />
              Properties
            </button>
            <button
              className={`toggle-btn ${activeTab === "seo" ? "active" : ""}`}
              onClick={() => setActiveTab("seo")}
            >
              <FiSearch size={15} />
              SEO
            </button>
            <button
              className={`toggle-btn ${activeTab === "general" ? "active" : ""
                }`}
              onClick={() => setActiveTab("general")}
            >
              <FiSettings size={15} />
              Settings
            </button>
          </div>

          {activeTab === "properties" && (
            <>
              <div className="panel-content d-flex flex-column position-relative">
                {selectedComponent ? (
                  <div className="property-groups">
                    {/* Text Content Input - for non-image elements */}
                    {selectedComponent.get("tagName") !== "img" && (
                      <div className="property-group">
                        <label className="property-label">Text Content</label>

                        <textarea
                          value={componentContent}
                          onChange={(e) => {
                            const value = e.target.value;
                            const tag = selectedComponent.get("tagName");

                            if (tag === "button") {
                              if (value.length <= 20) {
                                setComponentContent(value);
                                setError("");
                              } else {
                                setError(
                                  "Button text cannot exceed 20 characters.",
                                );
                              }
                            } else {
                              setComponentContent(value);
                              setError("");
                            }
                          }}
                          className="property-input"
                          rows={3}
                          placeholder="Enter text content..."
                          disabled={isLoading}
                        />

                        {/* Error message */}
                        {selectedComponent.get("tagName") === "button" &&
                          error && (
                            <p
                              className="error-text"
                              style={{ color: "red", marginTop: "5px" }}
                            >
                              {error}
                            </p>
                          )}
                      </div>
                    )}

                    {/* Link URL Input - for links and buttons */}
                    {(selectedComponent.get("tagName") === "a" ||
                      selectedComponent.get("tagName") === "button" ||
                      selectedComponent.getAttributes().href !== undefined) && (
                        <div className="property-group">
                          <label className="property-label">Link URL</label>
                          <input
                            type="text"
                            value={componentHref}
                            onChange={(e) => setComponentHref(e.target.value)}
                            className="property-input"
                            placeholder="https://example.com"
                            disabled={isLoading}
                          />
                        </div>
                      )}

                    {/* Image Properties - for image elements */}
                    {selectedComponent.get("tagName") === "img" && (
                      <>
                        <div className="property-group">
                          <div className="property-group">
                            <label className="property-label">
                              Select from Uploaded Images
                            </label>
                            <select
                              value=""
                              onChange={(e) => {
                                if (e.target.value) {
                                  setImageUrlInput(e.target.value);
                                  handleImageUrl({
                                    target: { value: e.target.value },
                                  });
                                }
                              }}
                              className="property-input"
                              disabled={
                                isLoading ||
                                !Array.isArray(assetsCollection) ||
                                assetsCollection.length === 0
                              }
                            >
                              <option value="">
                                Choose an uploaded image...
                              </option>
                              {Array.isArray(assetsCollection) &&
                                assetsCollection.map((asset, index) => {
                                  const imageUrl =
                                    typeof asset === "string"
                                      ? asset
                                      : asset.fileUrl ||
                                      asset.src ||
                                      asset.path;
                                  const imageName =
                                    typeof asset === "string"
                                      ? asset.split("/").pop()
                                      : asset.name ||
                                      asset.filename ||
                                      imageUrl?.split("/").pop() ||
                                      `Image ${index + 1}`;

                                  return (
                                    <option key={index} value={imageUrl}>
                                      {imageName}
                                    </option>
                                  );
                                })}
                            </select>
                            {(!Array.isArray(assetsCollection) ||
                              assetsCollection.length === 0) && (
                                <small className="help-text">
                                  No uploaded images found
                                </small>
                              )}
                          </div>
                          <div className="divider-text">OR</div>
                          <label className="property-label">
                            Upload New Image
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                            className="property-input"
                            disabled={isLoading}
                          />
                          <div className="divider-text">OR</div>
                          <label className="property-label">Image URL</label>
                          <div className="url-input-group">
                            <input
                              type="url"
                              value={imageUrlInput}
                              onChange={(e) => setImageUrlInput(e.target.value)}
                              onBlur={handleImageUrl}
                              className="property-input"
                              placeholder="https://example.com/image.jpg"
                              disabled={isLoading}
                            />
                            <button
                              type="button"
                              style={{
                                marginTop: "10px",
                                backgroundColor: "#007bff",
                                color: "white",
                                borderRadius: "20px",
                                cursor: "pointer",
                                border: "none",
                              }}
                              onClick={() =>
                                handleImageUrl({
                                  target: { value: imageUrlInput },
                                })
                              }
                              className="apply-url-btn"
                              disabled={isLoading || !imageUrlInput.trim()}
                            >
                              Apply
                            </button>
                          </div>
                          <small className="help-text">
                            Enter a direct link to an image file
                          </small>
                        </div>

                        <div className="property-group">
                          <label className="property-label">
                            Image Alt Text
                          </label>
                          <input
                            type="text"
                            value={componentAlt}
                            onChange={(e) => setComponentAlt(e.target.value)}
                            className="property-input"
                            placeholder="Enter alt text for image"
                            disabled={isLoading}
                          />
                        </div>
                      </>
                    )}

                    {/* Video Properties - for video elements */}
                    {selectedComponent.get("tagName") === "video" && (
                      <>
                        <div className="property-group">
                          {/* <div className="property-group">
                            <label className="property-label">Select from Uploaded Videos</label>
                            <select
                              value=""
                              onChange={(e) => {
                                if (e.target.value) {
                                  setImageUrlInput(e.target.value);
                                  handleImageUrl({ target: { value: e.target.value } });
                                }
                              }}
                              className="property-input"
                              disabled={isLoading || !Array.isArray(assetsCollection) || assetsCollection.length === 0}
                            >
                              <option value="">Choose an uploaded image...</option>
                              {Array.isArray(assetsCollection) && assetsCollection.map((asset, index) => {
                                const imageUrl = typeof asset === 'string' ? asset : (asset.fileUrl || asset.src || asset.path);
                                const imageName = typeof asset === 'string'
                                  ? asset.split('/').pop()
                                  : (asset.name || asset.filename || imageUrl?.split('/').pop() || `Image ${index + 1}`);

                                return (
                                  <option key={index} value={imageUrl}>
                                    {imageName}
                                  </option>
                                );
                              })}
                            </select>
                            {(!Array.isArray(assetsCollection) || assetsCollection.length === 0) && (
                              <small className="help-text">No uploaded Videos found</small>
                            )}
                          </div> */}

                          {/* <div className="divider-text">OR</div>
                          <label className="property-label">
                            Upload New Image
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                            className="property-input"
                            disabled={isLoading}
                          /> */}

                          {/* <div className="divider-text">OR</div> */}
                          <label className="property-label">Video URL</label>
                          <div className="url-input-group">
                            <input
                              type="url"
                              value={imageUrlInput}
                              onChange={(e) => setImageUrlInput(e.target.value)}
                              onBlur={handleImageUrl}
                              className="property-input"
                              placeholder="https://example.com/image.jpg"
                              disabled={isLoading}
                            />
                            <button
                              type="button"
                              style={{
                                marginTop: "10px",
                                backgroundColor: "#007bff",
                                color: "white",
                                borderRadius: "20px",
                                cursor: "pointer",
                                border: "none",
                              }}
                              onClick={() =>
                                handleImageUrl({
                                  target: { value: imageUrlInput },
                                })
                              }
                              className="apply-url-btn"
                              disabled={isLoading || ""}
                            >
                              Apply
                            </button>
                          </div>
                          <small className="help-text">
                            Enter a direct link to an video file
                          </small>
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="no-selection">
                    <div className="no-selection-icon">🎯</div>
                    <p>
                      Select a text element, link, button, or image to edit its
                      properties.
                    </p>
                    <small>
                      Click on any editable element in the canvas to start
                      editing.
                    </small>
                  </div>
                )}

              </div>
              <div className="d-flex justify-content-end p-2 border-top">
                <Button
                  variant="primary"
                  className="d-flex justify-content-center align-items-center rounded-circle p-2"
                  onClick={handleShow}
                >
                  <FaRobot size={25} />
                </Button>
              </div>

                <Offcanvas
                  show={show}
                  onHide={handleClose}
                  placement="bottom"
                  scroll={true}
                  backdrop={false}
                  // style={{ width: "24%" }}
                  className={`custom-offCanvas ${aiExpanded ? "ai-expanded" : ""}`}
                >
                  <Offcanvas.Header closeButton className="ai-offcanvas-header bg-primary" style={{ height: "70px" }}>

                    {/* <Image src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg" roundedCircle width={25} height={25} className="object-fit-cover me-2" /> */}
                    <div className="ai-header-text">
                      <Offcanvas.Title className="text-white mb-0">AI Assistant</Offcanvas.Title>
                      <small className="ai-header-subtitle">Ask me about your site</small>
                    </div>
                    <button
                      type="button"
                      className="ai-expand-btn"
                      onClick={() => setAiExpanded((v) => !v)}
                      title={aiExpanded ? "Collapse" : "Expand"}
                    >
                      {aiExpanded ? <FiMinimize2 size={16} /> : <FiMaximize2 size={16} />}
                    </button>

                  </Offcanvas.Header>


                  <Offcanvas.Body className="p-0">
                    {/* <AiChat
                      adapter={adapter}
                      // onSend={message => {return "Hello World"}}
                      personaOptions={{
                        assistant: {
                          name: "Turbosteed Ai Helper",
                          avatar:
                            "https://images.pexels.com/photos/8294606/pexels-photo-8294606.jpeg",
                          tagline:
                            "Turbosteed Ai assistant is ready to help you",
                        },
                        user: {
                          name: "user",
                          avatar: "https://plus.unsplash.com/premium_photo-1677094310899-02303289cadf?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cm9ib3R8ZW58MHx8MHx8fDA%3D",
                        },
                      }}
                      displayOptions={{ colorScheme: "light", height: "100%" }}
                      initialConversation={[
                        {
                          role: "assistant",
                          message: "Hii! I am turbosteed chatbot. How can I help you ?",
                        },
                      ]}
                      conversationOptions={
                        {
                          history: true,
                        }
                      }
                    /> */}

                    <div className="h-100">
                      <MainContainer>
                        <ChatContainer className="pt-2">
                          <MessageList>

                            {message.length === 0 && (
                              <Message model={{ message: "Hi! I'm your AI Assistant. For now, I can help you modify text and add icons on your site. Just tell me what you'd like to change!", sender: "AI Assistant", direction: "incoming", position: "single" }}>
                                <Avatar name="AI" src="https://cdn-icons-png.flaticon.com/512/4712/4712109.png" />
                              </Message>
                            )}

                            {message.map((m, i) => {
                              if (m.isUploading) {
                                return (
                                  <Message key={i} model={{ sender: "User", direction: "outgoing", position: "single" }}>
                                    <Avatar name="Eliot" src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" />
                                    <Message.CustomContent>
                                      <div className="ai-chat-upload-loader">
                                        <div className="ai-chat-loader-dots">
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                        </div>
                                        <span className="upload-text">Uploading image...</span>
                                      </div>
                                    </Message.CustomContent>
                                  </Message>
                                );
                              }
                              if (m.isLoading) {
                                return (
                                  <Message key={i} model={{ sender: "Zoe", direction: "incoming", position: "single" }}>
                                    <Avatar name="Joe" src="https://cdn-icons-png.flaticon.com/512/4712/4712109.png" />
                                    <Message.CustomContent>
                                      <div className="ai-chat-loader-dots">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                      </div>
                                    </Message.CustomContent>
                                  </Message>
                                );
                              }
                              return <Message key={i} {...m?.props} />
                            })}

                          </MessageList>

                          <MessageInput placeholder="Type message here" onSend={handleAiChat} onAttachClick={() => { if (!messageLoader) fileRef.current.click(); }} disabled={messageLoader} autoFocus />

                          {/* <AttachmentButton
                            style={{
                              fontSize: "2em",
                              paddingLeft: "0.2em",
                              paddingRight: "0.2em"
                            }}
                            onClick={() => fileRef.current.click()}
                            onSend={handleFileUpload}
                          />

                          <input type='file' id='file' ref={fileRef} style={{display: 'none'}}/> */}
                        </ChatContainer>
                      </MainContainer>
                    </div>

                  </Offcanvas.Body>

                </Offcanvas>
            </>
          )}

          <input
            type="file"
            id="file"
            ref={fileRef}
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />

          {/* SEO Panel */}
          {activeTab === "seo" && (
            <div className="seo-panel">
              <div className="property-group mt-3 p-3 shadow rounded">
                <div className="d-flex justify-content-between px-1" >
                  <label>Page Title</label>

                  {/* ToolTip */}
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 100 }}
                    overlay={
                      <Tooltip id="button-tooltip-1" className="seo-tooltip">
                        People will see this title in Google Search result and
                        in the browser tab
                      </Tooltip>
                    }
                  >
                    <span style={{ overflow: "hidden" }}>
                      <BsInfoCircleFill
                        size={15}
                        color="#0d7ce9"
                        className="pointer"
                      />
                    </span>
                  </OverlayTrigger>
                </div>

                <input
                  type="text"
                  value={seoData?.meta_title}
                  onChange={(e) => handleSeoChange("meta_title", e.target.value)}
                  placeholder="Enter page title"
                  disabled={isLoading}
                  className="property-input"
                />
              </div>

              <div className="property-group p-3 shadow rounded">
                <div className="d-flex justify-content-between px-1">
                  <label>Meta Description</label>

                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 100 }}
                    overlay={
                      <Tooltip id="button-tooltip-2" className="seo-tooltip">
                        A short summary that appears in Google Search results to
                        describe this page. Keep it max 100 characters
                      </Tooltip>
                    }
                  >
                    <span style={{ overflow: "hidden" }}>
                      <BsInfoCircleFill size={15} color="#0d7ce9" />
                    </span>
                  </OverlayTrigger>
                </div>

                <textarea
                  value={seoData?.meta_description}
                  onChange={(e) =>
                    handleSeoChange("meta_description", e.target.value)
                  }
                  placeholder="Enter meta description"
                  rows={3}
                  disabled={isLoading}
                  className="property-input"
                />
              </div>

              <Accordion className="property-group mx-0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Advanced SEO Settings</Accordion.Header>
                  <Accordion.Body className="px-0">
                    {/* Meta Keywords */}
                    <div className="property-group p-3 shadow rounded">
                      <div className="d-flex justify-content-between px-1">
                        <label>Meta Keywords</label>

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 100 }}
                          overlay={
                            <Tooltip id="button-tooltip-3" className="seo-tooltip">
                              Words or phrases that help Google Search
                              understand what this page is about
                            </Tooltip>
                          }
                        >
                          <span style={{ overflow: "hidden" }}>
                            <BsInfoCircleFill size={15} color="#0d7ce9" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <input
                        type="text"
                        value={seoData?.keywords}
                        onChange={(e) =>
                          handleSeoChange("keywords", e.target.value)
                        }
                        placeholder="Enter keywords, comma separated"
                        disabled={isLoading}
                        className="property-input"
                      />
                    </div>

                    {/* Meta Canonical Url */}
                    <div className="property-group p-3 shadow rounded">
                      <div className="d-flex justify-content-between px-1">
                        <label>Canonical Url</label>

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 100 }}
                          overlay={
                            <Tooltip id="button-tooltip-4" className="seo-tooltip">
                              The main URL you want search engines to show for
                              this page
                            </Tooltip>
                          }
                        >
                          <span style={{ overflow: "hidden" }}>
                            <BsInfoCircleFill size={15} color="#0d7ce9" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <input
                        type="text"
                        value={seoData?.canonicalUrl}
                        // onChange={() => handleSeoChange("canonicalUrl", customDomain !== ""? `${customDomain}/${templateData.templateFiles.templatePageURLs[selectedPageIndex]}` : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/${templateData.templateFiles.templatePageURLs[selectedPageIndex]}` )}
                        placeholder="Auto Generated"
                        disabled={true}
                        className="property-input"
                      />
                    </div>

                    {/* SEO Robots */}
                    {/* <div className="property-group p-3 shadow rounded">
                      <div className="d-flex justify-content-between px-1">
                        <label>Robots</label>

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 100 }}
                          overlay={<Tooltip id="button-tooltip-2" className="seo-tooltip">Control how search engines access and display this page, including indexing and link following</Tooltip>}
                        >
                          <span style={{ overflow: "hidden" }}>
                            <BsInfoCircleFill size={15} color="#0d7ce9" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <input
                        type="text"
                        value={seoData.robots}
                        onChange={(e) => handleSeoChange("robots", e.target.value)}
                        placeholder="Enter robots content"
                        disabled={isLoading}
                        className="property-input"
                      />
                    </div> */}

                    {/* OG:Type */}
                    <div className="property-group p-3 shadow rounded">
                      <div className="d-flex justify-content-between px-1">
                        <label>Og:Type</label>

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 100 }}
                          overlay={
                            <Tooltip id="button-tooltip-5" className="seo-tooltip">
                              Tells social platforms what kind of content this
                              is, so it displays correctly when shared
                            </Tooltip>
                          }
                        >
                          <span style={{ overflow: "hidden" }}>
                            <BsInfoCircleFill size={15} color="#0d7ce9" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <input
                        type="text"
                        value={seoData?.ogType}
                        onChange={(e) =>
                          handleSeoChange("ogType", e.target.value)
                        }
                        placeholder="Enter OgType content"
                        disabled={isLoading}
                        className="property-input"
                      />
                    </div>

                    {/* Og:Url */}
                    {/* <div className="property-group p-3 shadow rounded">
                      <div className="d-flex justify-content-between px-1">
                        <label>Og:Url</label>

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 100 }}
                          overlay={<Tooltip id="button-tooltip-2" className="seo-tooltip">The full link you want social media to use when this page is shared</Tooltip>}
                        >
                          <span style={{ overflow: "hidden" }}>
                            <BsInfoCircleFill size={15} color="#0d7ce9" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <input
                        type="text"
                        value={seoData.ogUrl}
                        onChange={(e) => handleSeoChange("ogUrl", e.target.value)}
                        placeholder="Enter OgUrl content"
                        disabled={isLoading}
                        className="property-input"
                      />
                    </div> */}

                    {/* Og:Title */}
                    <div className="property-group p-3 shadow rounded">
                      <div className="d-flex justify-content-between px-1">
                        <label>Og:Title</label>

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 100 }}
                          overlay={
                            <Tooltip id="button-tooltip-6" className="seo-tooltip">
                              The title that will show when this page is shared
                              on social media
                            </Tooltip>
                          }
                        >
                          <span style={{ overflow: "hidden" }}>
                            <BsInfoCircleFill size={15} color="#0d7ce9" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <input
                        type="text"
                        value={seoData?.og_title}
                        onChange={(e) =>
                          handleSeoChange("ogTitle", e.target.value)
                        }
                        placeholder="Enter OgTitle content"
                        disabled={isLoading}
                        className="property-input"
                      />
                    </div>

                    {/* Og:Description */}
                    <div className="property-group p-3 shadow rounded">
                      <div className="d-flex justify-content-between px-1">
                        <label>Og:Description</label>

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 100 }}
                          overlay={
                            <Tooltip id="button-tooltip-7" className="seo-tooltip">
                              Helps social platforms show a clear summary of
                              this page in the preview when it’s shared
                            </Tooltip>
                          }
                        >
                          <span style={{ overflow: "hidden" }}>
                            <BsInfoCircleFill size={15} color="#0d7ce9" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <input
                        type="text"
                        value={seoData?.og_description}
                        onChange={(e) =>
                          handleSeoChange("ogDescription", e.target.value)
                        }
                        placeholder="Enter OgDescription content"
                        disabled={isLoading}
                        className="property-input"
                      />
                    </div>

                    {/* Og:Image */}
                    <div className="property-group shadow rounded">
                      <div className="property-group">
                        <div className="d-flex justify-content-between px-1">
                          <label>Og:Image</label>

                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 100 }}
                            overlay={
                              <Tooltip id="button-tooltip-8" className="seo-tooltip">
                                The image that will show when this page is
                                shared on social media
                              </Tooltip>
                            }
                          >
                            <span style={{ overflow: "hidden" }}>
                              <BsInfoCircleFill size={15} color="#0d7ce9" />
                            </span>
                          </OverlayTrigger>
                        </div>

                        <input
                          type="text"
                          value={seoData?.ogImage}
                          onChange={(e) =>
                            handleSeoChange("ogImage", e.target.value)
                          }
                          placeholder="Enter Image content"
                          disabled={true}
                          className="property-input"
                        />
                      </div>

                      <div className="property-group">
                        <div className="property-group px-0 m-0">
                          <label className="property-label">
                            Select from Uploaded Images
                          </label>
                          <select
                            value=""
                            onChange={(e) => {
                              if (e.target.value) {
                                setImageUrlInput(e.target.value);
                                handleImageUrl({
                                  target: { value: e.target.value },
                                });
                                handleSeoChange("ogImage", e.target.value);
                              }
                            }}
                            className="property-input"
                            disabled={
                              isLoading ||
                              !Array.isArray(assetsCollection) ||
                              assetsCollection.length === 0
                            }
                          >
                            <option value="">
                              Choose an uploaded image...
                            </option>
                            {Array.isArray(assetsCollection) &&
                              assetsCollection.map((asset, index) => {
                                const imageUrl =
                                  typeof asset === "string"
                                    ? asset
                                    : asset.fileUrl || asset.src || asset.path;
                                const imageName =
                                  typeof asset === "string"
                                    ? asset.split("/").pop()
                                    : asset.name ||
                                    asset.filename ||
                                    imageUrl?.split("/").pop() ||
                                    `Image ${index + 1}`;

                                return (
                                  <option key={index} value={imageUrl}>
                                    {imageName}
                                  </option>
                                );
                              })}
                          </select>
                          {(!Array.isArray(assetsCollection) ||
                            assetsCollection.length === 0) && (
                              <small className="help-text">
                                No uploaded images found
                              </small>
                            )}
                        </div>
                        <div className="divider-text">OR</div>
                        <label className="property-label">
                          Upload New Image
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleSEOImageUpload}
                          className="property-input"
                          disabled={isLoading}
                        />
                        <div className="divider-text">OR</div>
                        <label className="property-label">Image URL</label>
                        <div className="url-input-group">
                          <input
                            type="url"
                            value={imageUrlInput}
                            onChange={(e) => {
                              setImageUrlInput(e.target.value);
                              handleSeoChange("ogImage", e.target.value);
                            }}
                            onBlur={handleImageUrl}
                            className="property-input"
                            placeholder="https://example.com/image.jpg"
                            disabled={isLoading}
                          />
                          {/* <button
                    type="button"
                    style={{
                      marginTop: "10px",
                      backgroundColor: "#007bff",
                      color: "white",
                      borderRadius: "20px",
                      cursor: "pointer",
                      border: "none",
                    }}
                    onClick={() =>
                      handleImageUrl({
                        target: { value: imageUrlInput },
                      })
                    }
                    className="apply-url-btn"
                    disabled={isLoading || !imageUrlInput.trim()}
                  >
                    Apply
                  </button> */}
                        </div>
                        <small className="help-text">
                          Enter a direct link to an image file
                        </small>
                      </div>
                    </div>

                    {/* Twitter Card */}
                    <div className="property-group p-3 shadow rounded">
                      <div className="d-flex justify-content-between px-1">
                        <label>Twiiter Card</label>

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 100 }}
                          overlay={
                            <Tooltip id="button-tooltip-9" className="seo-tooltip">
                              Choose how this page will appear when shared on
                              Twitter
                            </Tooltip>
                          }
                        >
                          <span style={{ overflow: "hidden" }}>
                            <BsInfoCircleFill size={15} color="#0d7ce9" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <input
                        type="text"
                        value={seoData?.twitterCard}
                        onChange={(e) =>
                          handleSeoChange("twitterCard", e.target.value)
                        }
                        placeholder="Enter twitter card content"
                        disabled={isLoading}
                        className="property-input"
                      />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          )}

          {activeTab === "general" && (
            <>
              <div className="general-settings-panel p-3 overflow-y-auto" ref={settingsPanelRef}>
                {!showCustomColorPicker &&
                  !showCustomFontPicker &&
                  !showColorThemes &&
                  !showFontThemes &&
                  !showCustomCodeEditor && (
                    <>
                      {/* Favicon section */}
                      <div className="property-group p-3 shadow rounded">
                        <label className="property-label">Favicon</label>
                        <input
                          type="file"
                          accept="image/x-icon,image/vnd.microsoft.icon,image/png,image/jpeg,image/jpg"
                          onChange={handleFaviconUpload}
                          className="property-input"
                          disabled={isLoading}
                        />
                        <div className="divider-text">OR</div>
                        <label className="property-label">Favicon URL</label>
                        <div className="url-input-group">
                          <input
                            type="url"
                            value={faviconUrlInput}
                            onChange={(e) => setFaviconUrlInput(e.target.value)}
                            className="property-input"
                            placeholder="https://example.com/favicon.ico"
                            disabled={isLoading}
                          />
                          <button
                            type="button"
                            style={{
                              marginTop: "10px",
                              backgroundColor: "#007bff",
                              color: "white",
                              borderRadius: "20px",
                              cursor: "pointer",
                              border: "none",
                              padding: "5px 15px",
                            }}
                            onClick={() =>
                              handleFaviconUrl({
                                target: { value: faviconUrlInput },
                              })
                            }
                            className="apply-url-btn"
                            disabled={isLoading || !faviconUrlInput.trim()}
                          >
                            Apply
                          </button>
                        </div>
                        <small className="help-text">
                          Upload or enter URL for favicon (ICO, PNG, JPG format
                          recommended)
                        </small>
                      </div>


                      <div
                        className="settings-card shadow"
                        onClick={() => setShowCustomColorPicker(true)}
                      >
                        <div className="settings-card-icon">🎨</div>
                        <div className="settings-card-content">
                          <h4>Color Theme</h4>
                          <p>Customize your website's color scheme</p>
                          <div className="color-preview-strip">
                            {editableTheme &&
                              Object.entries(editableTheme)
                                .slice(0, 4)
                                .map(([property, value]) => (
                                  <div
                                    key={property}
                                    className="color-preview-dot"
                                    style={{ backgroundColor: value }}
                                    title={`${getVariableFriendlyName(
                                      property,
                                    )}: ${value}`}
                                  />
                                ))}
                            {Object.keys(editableTheme).length > 4 && (
                              <span className="more-colors">
                                +{Object.keys(editableTheme).length - 4}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="settings-card-arrow">→</div>
                      </div>

                      <div
                        className="settings-card shadow"
                        onClick={() => setShowCustomFontPicker(true)}
                      >
                        <div className="settings-card-icon">🔤</div>
                        <div className="settings-card-content">
                          <h4>Font Theme</h4>
                          <p>Choose fonts for your website</p>
                          <div className="font-preview">
                            {editableFonts["--font-primary"] && (
                              <span
                                style={{
                                  fontFamily:
                                    editableFonts["--font-primary"].split(
                                      ",",
                                    )[0],
                                }}
                              >
                                Aa
                              </span>
                            )}
                            <span className="font-theme-name">
                              {selectedFontTheme || "Custom"}
                            </span>
                          </div>
                        </div>
                        <div className="settings-card-arrow">→</div>
                      </div>

                      {/* Custom Code card */}
                      <div
                        className="settings-card shadow"
                        onClick={handleOpenCustomCode}
                      >
                        <div className="settings-card-icon">{"</>"}</div>
                        <div className="settings-card-content">
                          <h4>Custom Code</h4>
                          <p>Add JavaScript to this page's head</p>
                          {customCode.head_js && (
                            <span style={{ fontSize: '11px', color: '#28a745' }}>● Script active</span>
                          )}
                        </div>
                        <div className="settings-card-arrow">→</div>
                      </div>
                    </>
                  )}

                {showCustomColorPicker && !showColorThemes && (
                  <>
                    <div className="panel-header">
                      <button
                        className="back-button"
                        onClick={() => setShowCustomColorPicker(false)}
                      >
                        <i className="bi bi-arrow-left-square-fill"></i> Back
                      </button>
                      <h3>Color Theme</h3>
                    </div>

                    <div className="full-screen-picker bg-light">
                      <div className="container py-3 shadow mb-1 d-flex flex-column align-items-center justify-content-center">
                        <div className="d-flex flex-row align-items-center gap-1">
                          {editableTheme &&
                            Object.entries(editableTheme)
                              .slice(0, 5)
                              .map(([property, value]) => (
                                <div
                                  key={property}
                                  className="d-flex flex-row align-items-center justify-content-center"
                                >
                                  <div className="text-center d-flex flex-row">
                                    <div
                                      className="color-rect border"
                                      style={{
                                        width: "40px",
                                        height: "50px",
                                        borderRadius: "8px",
                                        backgroundColor: value,
                                      }}
                                      title={`${getVariableFriendlyName(
                                        property,
                                      )}: ${value}`}
                                    />
                                  </div>
                                </div>
                              ))}
                        </div>
                        <h5 className="pt-2" style={{ fontSize: "1.2rem" }}>
                          Theme Name: {selectedColorTheme || "Custom"}
                        </h5>
                        <button
                          className="bg-primary border-0 p-2 rounded text-light fw-bold"
                          onClick={() => setShowColorThemes(true)}
                        >
                          Select Theme
                        </button>
                      </div>

                      <div className="custom-colors-section">
                        <div className="p-3">
                          <h4>Custom Colors</h4>
                        </div>
                        <div className="custom-colors-grid">
                          {editableTheme &&
                            Object.entries(editableTheme).map(
                              ([property, value]) => (
                                <div
                                  key={property}
                                  className="color-editor-card"
                                >
                                  <div className="color-header">
                                    <span className="color-name">
                                      {getVariableFriendlyName(property)}
                                    </span>
                                    <span className="color-value">{value}</span>
                                  </div>
                                  <div className="color-controls">
                                    <input
                                      type="color"
                                      value={
                                        value.startsWith("#")
                                          ? value
                                          : "#ffffff"
                                      }
                                      onChange={(e) =>
                                        handleThemeColorChange(
                                          property,
                                          e.target.value,
                                        )
                                      }
                                      className="color-input rounded-3"
                                      disabled={isLoading}
                                    />
                                    <input
                                      type="text"
                                      value={value}
                                      onChange={(e) =>
                                        handleThemeColorChange(
                                          property,
                                          e.target.value,
                                        )
                                      }
                                      className="color-text-input p-2"
                                      placeholder="#ffffff"
                                      disabled={isLoading}
                                    />
                                  </div>
                                </div>
                              ),
                            )}
                        </div>
                      </div>

                      <div className="picker-actions">
                        <button
                          onClick={resetThemeToOriginal}
                          className="reset-button"
                          disabled={isLoading}
                        >
                          Reset to Original
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {showColorThemes && (
                  <div className="full-screen-picker">
                    <div className="panel-header">
                      <button
                        className="back-button"
                        onClick={() => setShowColorThemes(false)}
                      >
                        <i className="bi bi-arrow-left-square-fill"></i> Back
                      </button>
                      <h3>Choose Color Theme</h3>
                    </div>

                    <div className="theme-selection-section pt-2">
                      <div className="color-theme-grid">
                        {Object.entries(colorThemes).map(
                          ([themeName, themeColors]) =>
                            templateThemes[templateId].includes(themeName) ? (
                              <div
                                key={themeName}
                                className={`color-theme-card ${selectedColorTheme === themeName
                                  ? "active"
                                  : ""
                                  }`}
                                onClick={() => {
                                  handleColorThemeChange(themeName);
                                  setShowColorThemes(false);
                                }}
                              >
                                <div className="color-theme-preview">
                                  <div className="color-strip">
                                    {Object.entries(themeColors)
                                      .slice(0, 5)
                                      .map(([colorProperty, colorValue]) => (
                                        <div
                                          key={colorProperty}
                                          className="color-swatch"
                                          style={{
                                            backgroundColor: colorValue,
                                          }}
                                          title={`${getVariableFriendlyName(
                                            colorProperty,
                                          )}: ${colorValue}`}
                                        />
                                      ))}
                                  </div>
                                  <div className="color-theme-info">
                                    <div className="color-theme-name">
                                      {themeName.charAt(0).toUpperCase() +
                                        themeName.slice(1)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null,
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {showCustomFontPicker && !showFontThemes && (
                  <div className="full-screen-picker">
                    <div className="panel-header">
                      <button
                        className="back-button"
                        onClick={() => setShowCustomFontPicker(false)}
                      >
                        <i className="bi bi-arrow-left-square-fill"></i> Back
                      </button>
                      <h3>Font Theme</h3>
                    </div>

                    <div className="container py-3 shadow mb-1 d-flex flex-column align-items-center justify-content-center">
                      <div className="d-flex flex-row align-items-center gap-1">
                        {editableFonts["--font-primary"] && (
                          <span
                            style={{
                              fontFamily:
                                editableFonts["--font-primary"].split(",")[0],
                              fontSize: "24px",
                              fontWeight: "bold",
                            }}
                          >
                            Aa
                          </span>
                        )}
                      </div>
                      <h5 className="pt-2" style={{ fontSize: "1.2rem" }}>
                        Theme Name: {selectedFontTheme || "Custom"}
                      </h5>
                      <button
                        className="bg-primary border-0 p-2 rounded text-light fw-bold"
                        onClick={() => setShowFontThemes(true)}
                      >
                        Select Theme
                      </button>
                    </div>

                    {/* Custom font editing */}
                    <div className="custom-fonts-section">
                      <div
                        className="panel-header"
                        style={{ textAlign: "right" }}
                      >
                        <h3>Custom Fonts</h3>
                      </div>
                      <div className="custom-fonts-grid mt-2">
                        {editableFonts &&
                          Object.entries(editableFonts).map(
                            ([property, value]) => (
                              <div key={property} className="font-editor-card">
                                <div className="font-header">
                                  <span className="font-label">
                                    {getFontFriendlyName(property)}
                                  </span>
                                </div>

                                {property.includes("family") ? (
                                  <select
                                    value={value}
                                    onChange={(e) =>
                                      handleFontChange(property, e.target.value)
                                    }
                                    className="font-select"
                                    disabled={isLoading}
                                    style={{ fontFamily: value.split(",")[0] }}
                                  >
                                    <option value="">
                                      Select font family...
                                    </option>
                                    <option value="Arial, sans-serif">
                                      Arial
                                    </option>
                                    <option value="Georgia, serif">
                                      Georgia
                                    </option>
                                    <option value="'Times New Roman', serif">
                                      Times New Roman
                                    </option>
                                    <option value="Helvetica, sans-serif">
                                      Helvetica
                                    </option>
                                    <option value="'Trebuchet MS', sans-serif">
                                      Trebuchet MS
                                    </option>
                                    <option value="Verdana, sans-serif">
                                      Verdana
                                    </option>
                                    <option value="'Courier New', monospace">
                                      Courier New
                                    </option>
                                  </select>
                                ) : (
                                  <input
                                    type="text"
                                    value={value}
                                    onChange={(e) =>
                                      handleFontChange(property, e.target.value)
                                    }
                                    className="font-input"
                                    placeholder={`Enter value for ${property.replace(
                                      "--font-",
                                      "",
                                    )}`}
                                    disabled={isLoading}
                                  />
                                )}

                                {property.includes("family") && value && (
                                  <div
                                    className="font-preview-sample"
                                    style={{ fontFamily: value.split(",")[0] }}
                                  >
                                    The quick brown fox jumps over the lazy dog
                                  </div>
                                )}
                              </div>
                            ),
                          )}
                      </div>
                    </div>

                    <div className="picker-actions">
                      <button
                        onClick={resetFontsToOriginal}
                        className="reset-button"
                        disabled={isLoading}
                      >
                        Reset to Original Fonts
                      </button>
                    </div>
                  </div>
                )}

                {/* Font Themes Selection - Only shown when "Select Theme" button is clicked */}
                {showFontThemes && (
                  <div className="full-screen-picker">
                    <div className="panel-header">
                      <button
                        className="back-button"
                        onClick={() => setShowFontThemes(false)}
                      >
                        <i className="bi bi-arrow-left-square-fill"></i> Back
                      </button>
                      <h3>Choose Font Theme</h3>
                    </div>

                    <div className="theme-selection-section pt-2">
                      <div className="font-theme-grid">
                        {Object.entries(fontThemes).map(
                          ([themeName, themeFonts]) => (
                            <div
                              key={themeName}
                              className={`font-theme-card ${selectedFontTheme === themeName ? "active" : ""
                                }`}
                              onClick={() => {
                                handleFontThemeChange(themeName);
                                setShowFontThemes(false); // Go back to custom editor
                              }}
                            >
                              <div className="font-theme-preview">
                                <div
                                  className="font-sample-large"
                                  style={{
                                    fontFamily:
                                      themeFonts["--font-primary"]?.split(
                                        ",",
                                      )[0] || "Arial",
                                  }}
                                >
                                  Aa
                                </div>
                                <div className="font-theme-info">
                                  <div className="font-theme-name">
                                    {themeName.charAt(0).toUpperCase() +
                                      themeName.slice(1)}
                                  </div>
                                  <div className="font-details">
                                    {
                                      themeFonts["--font-primary"]?.split(
                                        ",",
                                      )[0]
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {showCustomCodeEditor && (
                  <>
                    <div className="panel-header">
                      <button
                        className="back-button"
                        onClick={() => setShowCustomCodeEditor(false)}
                      >
                        <i className="bi bi-arrow-left-square-fill"></i> Back
                      </button>
                      <h3>Custom Code</h3>
                    </div>

                    <div className="cc-panel">
                      <div className="cc-intro">
                        <p className="cc-intro-title">Add custom JavaScript</p>
                        <p className="cc-intro-desc">
                          Add tracking, analytics, or other custom scripts. Global scripts apply to all pages. Page-specific scripts apply only to this page.
                        </p>
                      </div>

                      {/* Global JavaScript Section */}
                      <div className="cc-expandable-section">
                        <div
                          className="cc-expandable-header"
                          onClick={() => setGlobalSectionExpanded(!globalSectionExpanded)}
                        >
                          <span className="cc-expand-icon">{globalSectionExpanded ? '▼' : '▶'}</span>
                          <span className="cc-expandable-title">Global JavaScript (All Pages)</span>
                          <span className={`cc-status-indicator ${customCodeGlobal.head_js ? 'cc-status-active' : 'cc-status-empty'}`}>
                            {customCodeGlobal.head_js ? '● Active' : '○ Empty'}
                          </span>
                        </div>
                        {globalSectionExpanded && (
                          <div className={`cc-expandable-content${isLoading ? " cc-editor--disabled" : ""}`}>
                            {customCodeFetching ? (
                              <div className="cc-skeleton">
                                <div className="cc-skeleton-line" style={{ width: '75%' }} />
                                <div className="cc-skeleton-line" style={{ width: '55%' }} />
                                <div className="cc-skeleton-line" style={{ width: '85%' }} />
                              </div>
                            ) : (
                              <textarea
                                className="cc-editor-textarea"
                                rows={15}
                                placeholder="JavaScript that runs on every page..."
                                value={customCodeGlobal.head_js}
                                onChange={(e) => handleGlobalCodeChange(e.target.value)}
                                disabled={isLoading}
                                spellCheck={false}
                                autoComplete="off"
                              />
                            )}
                            {customCodeGlobal.head_js && (
                              <div className="cc-editor-bar">
                                <span className="cc-editor-active">● Applied to all pages</span>
                                <button
                                  className="cc-editor-clear"
                                  onClick={() => handleGlobalCodeChange("")}
                                  disabled={isLoading}
                                >
                                  Remove
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Page-Specific JavaScript Section */}
                      <div className="cc-expandable-section">
                        <div
                          className="cc-expandable-header"
                          onClick={() => setPageSectionExpanded(!pageSectionExpanded)}
                        >
                          <span className="cc-expand-icon">{pageSectionExpanded ? '▼' : '▶'}</span>
                          <span className="cc-expandable-title">This Page Only</span>
                          <span className={`cc-status-indicator ${customCode.head_js ? 'cc-status-active' : 'cc-status-empty'}`}>
                            {customCode.head_js ? '● Active' : '○ Empty'}
                          </span>
                        </div>
                        {pageSectionExpanded && (
                          <div className={`cc-expandable-content${isLoading ? " cc-editor--disabled" : ""}`}>
                            {customCodeFetching ? (
                              <div className="cc-skeleton">
                                <div className="cc-skeleton-line" style={{ width: '75%' }} />
                                <div className="cc-skeleton-line" style={{ width: '55%' }} />
                                <div className="cc-skeleton-line" style={{ width: '85%' }} />
                              </div>
                            ) : (
                              <textarea
                                className="cc-editor-textarea"
                                rows={15}
                                placeholder="JavaScript for this page only..."
                                value={customCode.head_js}
                                onChange={(e) => handleCustomCodeChange(e.target.value)}
                                disabled={isLoading}
                                spellCheck={false}
                                autoComplete="off"
                              />
                            )}
                            {customCode.head_js && (
                              <div className="cc-editor-bar">
                                <span className="cc-editor-active">● Applied to this page</span>
                                <button
                                  className="cc-editor-clear"
                                  onClick={() => handleCustomCodeChange("")}
                                  disabled={isLoading}
                                >
                                  Remove
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </>
          )}

        </div>

        <div className="editor-canvas">
          {loading ? (
            <Container
              fluid
              className="min-vh-100 d-flex align-items-center justify-content-center dashboard-bg"
            >
              <div className="text-center">
                <Spinner
                  animation="border"
                  variant="primary"
                  style={{ width: "2.5rem", height: "2.5rem" }}
                />
                <div className="mt-3 text-dashboard-secondary dashboard-text-base">
                  Loading...
                </div>
              </div>
            </Container>
          ) : (
            <></>
          )}
          {loadError ? (
            <div className="error-state">
              <h3>Failed to Load Page</h3>
              <p>{loadError}</p>
              <div className="error-actions">
                <button
                  onClick={() => {
                    setLoadError(null);
                    setSelectedPageIndex(selectedPageIndex);
                  }}
                  className="retry-btn"
                >
                  Retry
                </button>
                {selectedPageIndex > 0 && (
                  <button
                    onClick={() => setSelectedPageIndex(0)}
                    className="home-btn"
                  >
                    Go to Index
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div
              ref={containerRef}
              className="editor-container position-absolute z-0"
              style={{
                height: "100%",
                width: "100%",
                background: "#ffffff",
                margin: 0,
                padding: 0,
                overflow: "hidden",
                border: "1px solid #ddd",
              }}
            />
          )}

          <div className="assets-popover position-absolute bottom-10 end-10 z-3">
            <OverlayTrigger
              trigger="click"
              placement={"top"}
              show={showGallery}
              onToggle={(next) => setShowGallery(next)}
              // style={{ zIndex: 3 }}
              overlay={
                <Popover className="assets-gallery-popover">
                  <Popover.Header as="h3" className="d-flex justify-content-between align-items-center">
                    <span>Assets</span>
                    <button
                      type="button"
                      className="gallery-close-btn"
                      aria-label="Close"
                      onClick={() => setShowGallery(false)}
                    >
                      <FiX size={16} />
                    </button>
                  </Popover.Header>
                  <Popover.Body className="overflow-y-scroll" style={{ height: "50vh" }}>
                    <Container fluid >
                      <Row>
                        {Array.isArray(assetsCollection) &&
                          assetsCollection.map((asset, index) => {
                            const imageUrl =
                              typeof asset === "string"
                                ? asset
                                : asset.fileUrl || asset.src || asset.path;
                            return (
                              <Col key={index} md={6} lg={6} className="mb-3 image-card"><Image src={imageUrl} id="popover-image-asset" rounded width={100} height={100} style={{ cursor: "pointer" }} onClick={() => handleAiChat(imageUrl)} /></Col>
                            );
                          })}
                      </Row>
                      {(!Array.isArray(assetsCollection) ||
                        assetsCollection.length === 0) && (
                        <div className="assets-gallery-loader">
                          <Spinner animation="border" />
                          <span>Loading assets...</span>
                        </div>
                      )}
                    </Container>
                  </Popover.Body>
                </Popover>
              }
            >
              <Button variant="primary" className="d-flex justify-content-center align-items-center rounded-circle p-2"><FaFolderOpen size={25} /></Button>
            </OverlayTrigger>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TemplateEditor;
